document.addEventListener('DOMContentLoaded', function () {
  var htvPageLoadTime = Date.now();
  var page = document.querySelector('[data-htv-page]');
  if (!page) return;
  document.body.classList.add('htv-lock-header');
  var gridEl = document.querySelector('[data-htv-grid]');
  var overlay = document.querySelector('[data-htv-overlay]');
  var scroller = document.querySelector('[data-htv-overlay-scroller]');
  var gridCarousel = null;
  var gridTrack = null;
  var ghostGrid = null;
  var gridLoadingTimer = null;
  var gridLoadingToken = null;
  var placeholderLayer = null;
  var loadingCategory = null;
  var loadingLogged = false;
  var suppressGridClick = false;
  var CATEGORY_PLACEHOLDER_COUNT = 50;
  var CATEGORY_PLACEHOLDER_DELAY = 2000;
  var userHasScrolled = false;
  var gridInteracted = false;
  var autoScrollHintTimer = null;
  var autoScrollRunning = false;
  var autoScrollHintShown = false;
  var swipeHintTimer = null;
  var scrollHintTimer = null;
  var enableAutoLoad = null;
  var requestActivePagination = null;
  var prioritizeFirstPageLoad = null;
  var prefetchSequenceStarted = false;
  var prefetchSequenceCompleted = false;
  var postScrollTutorial = null;

  /* ============================================================
   * 1) HEADER + TOPBAR ALIGNMENT
   * ============================================================ */

  var topbar = document.querySelector('[data-htv-topbar]');
  var header = document.querySelector('.section-header');
  var announcement = document.querySelector('.announcement-bar-section');
  var headerTicking = false;

  function updateHeaderAndTopbarOffsets() {
    if (!topbar) return;

    var annHeight = announcement ? announcement.getBoundingClientRect().height : 0;
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var headerBottom = annHeight + headerHeight;

    document.documentElement.style.setProperty(
      '--htv-announcement-height',
      annHeight + 'px'
    );

    document.documentElement.style.setProperty(
      '--htv-header-height',
      headerHeight + 'px'
    );

    document.documentElement.style.setProperty(
      '--htv-header-stack-height',
      headerBottom + 'px'
    );

    // Sticky offset for control bar
    document.documentElement.style.setProperty(
      '--htv-header-offset',
      headerBottom + 'px'
    );

    // Overlay cards should live under the header row
    var overlayOffset = headerBottom + 20;
    document.documentElement.style.setProperty(
      '--htv-overlay-offset',
      overlayOffset + 'px'
    );

    // Align zoom/back button under menu icon
    var menu =
      document.querySelector('.header__icon--menu') ||
      document.querySelector('.header__icon--menu-drawer') ||
      document.querySelector('button.menu-toggle');

    if (menu) {
      var menuRect = menu.getBoundingClientRect();
      var barRect = topbar.getBoundingClientRect();
      var zoomOffset = menuRect.left - barRect.left;

      document.documentElement.style.setProperty(
        '--htv-zoom-margin-left',
        zoomOffset + 'px'
      );
    }
  }

  updateHeaderAndTopbarOffsets();
  window.addEventListener('resize', updateHeaderAndTopbarOffsets);
  window.addEventListener('scroll', function () {
    if (!autoScrollRunning && !userHasScrolled && (window.pageYOffset || document.documentElement.scrollTop || 0) > 0) {
      userHasScrolled = true;
      if (typeof prioritizeFirstPageLoad === 'function') {
        prioritizeFirstPageLoad();
      }
    }
    if (headerTicking) return;
    headerTicking = true;
    window.requestAnimationFrame(function () {
      updateHeaderAndTopbarOffsets();
      headerTicking = false;
    });
  });

  function cancelAutoScrollHint() {
    if (autoScrollHintTimer) {
      window.clearTimeout(autoScrollHintTimer);
      autoScrollHintTimer = null;
    }
    autoScrollRunning = false;
    hideSwipeHint();
    hideScrollHint();
  }

  function markGridInteraction() {
    if (gridInteracted) return;
    gridInteracted = true;
    cancelAutoScrollHint();
  }

  function showSwipeHint() {
    if (!page) return;
    hideScrollHint();
    var hint = page.querySelector('[data-htv-swipe-hint]');
    if (!hint) return;
    hint.classList.add('is-active');
    hint.setAttribute('aria-hidden', 'false');
    if (swipeHintTimer) {
      window.clearTimeout(swipeHintTimer);
    }
    swipeHintTimer = window.setTimeout(hideSwipeHint, 2200);
  }

  function hideSwipeHint() {
    if (!page) return;
    var hint = page.querySelector('[data-htv-swipe-hint]');
    if (!hint) return;
    hint.classList.remove('is-active');
    hint.setAttribute('aria-hidden', 'true');
    if (swipeHintTimer) {
      window.clearTimeout(swipeHintTimer);
      swipeHintTimer = null;
    }
  }

  function showScrollHint() {
    if (!page) return;
    hideSwipeHint();
    var hint = page.querySelector('[data-htv-scroll-hint]');
    if (!hint) return;
    hint.classList.add('is-active');
    hint.setAttribute('aria-hidden', 'false');
    if (scrollHintTimer) {
      window.clearTimeout(scrollHintTimer);
    }
    scrollHintTimer = window.setTimeout(hideScrollHint, 2200);
  }

  function hideScrollHint() {
    if (!page) return;
    var hint = page.querySelector('[data-htv-scroll-hint]');
    if (!hint) return;
    hint.classList.remove('is-active');
    hint.setAttribute('aria-hidden', 'true');
    if (scrollHintTimer) {
      window.clearTimeout(scrollHintTimer);
      scrollHintTimer = null;
    }
  }

  function startAutoScrollHint() {
    autoScrollHintTimer = null;
    if (autoScrollHintShown || userHasScrolled || gridInteracted) return;
    if (page.classList.contains('htv-page--overlay-active')) return;
    autoScrollHintShown = true;
    autoScrollRunning = true;
    showScrollHint();

    var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var targetY = startY + 120;
    var duration = 600;
    var hold = 600;
    var start = window.performance ? performance.now() : Date.now();

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(now) {
      if (!autoScrollRunning) return;
      var current = window.performance ? now : Date.now();
      var elapsed = current - start;
      if (elapsed <= duration) {
        var t = Math.min(1, elapsed / duration);
        var eased = easeInOut(t);
        window.scrollTo(0, startY + (targetY - startY) * eased);
        window.requestAnimationFrame(step);
        return;
      }

      if (elapsed <= duration + hold) {
        window.scrollTo(0, targetY);
        window.requestAnimationFrame(step);
        return;
      }

      var backElapsed = elapsed - duration - hold;
      var backT = Math.min(1, backElapsed / duration);
      var backEased = easeInOut(backT);
      window.scrollTo(0, targetY + (startY - targetY) * backEased);
      if (backT < 1) {
        window.requestAnimationFrame(step);
      } else {
        autoScrollRunning = false;
        if (typeof postScrollTutorial === 'function') {
          postScrollTutorial();
        }
      }
    }

    window.requestAnimationFrame(step);
  }

  function scheduleAutoScrollHint(delayMs) {
    if (autoScrollHintShown || autoScrollHintTimer || autoScrollRunning) return;
    if (userHasScrolled || gridInteracted) return;
    if (page.classList.contains('htv-page--overlay-active')) return;
    var delay = typeof delayMs === 'number' ? delayMs : 120;
    autoScrollHintTimer = window.setTimeout(startAutoScrollHint, delay);
  }

  ['wheel', 'touchstart', 'mousedown', 'keydown'].forEach(function (evtName) {
    document.addEventListener(evtName, cancelAutoScrollHint, { passive: true });
  });

  // Re-align offsets when the cart drawer opens/closes (body class toggles)
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl && 'MutationObserver' in window) {
    var lastScrollY = 0;
    var cartObserver = new MutationObserver(function () {
      var isActive = cartDrawerEl.classList.contains('active');
      if (isActive) {
        lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      } else {
        window.scrollTo(0, lastScrollY);
      }
      updateHeaderAndTopbarOffsets();
      window.setTimeout(updateHeaderAndTopbarOffsets, 150);
    });
    cartObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ============================================================
   * 2) MOBILE FOOTER HIDE (avoid footer vs. snap scroll)
   * ============================================================ */

  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
    document.body.classList.add('htv-hide-footer-mobile');
  }

  /* ============================================================
   * 3) ZOOM CONTROL + BACK BEHAVIOUR
   * ============================================================ */

  var zoomBtn = document.querySelector('.htv-zoom-toggle');
  var zoomClasses = [
    'htv-page--zoom-1', // 4 cols
    'htv-page--zoom-2', // 3 cols
    'htv-page--zoom-3', // 2 cols
    'htv-page--zoom-4'  // 1 col
  ];

  var currentIndex = zoomClasses.findIndex(function (cls) {
    return page.classList.contains(cls);
  });
  if (currentIndex === -1) {
    currentIndex = 0;
    page.classList.add(zoomClasses[currentIndex]);
  }

  // direction = 1  → next click zooms IN (fewer cols)
  // direction = -1 → next click zooms OUT (more cols)
  var direction = 1;

  function updateZoomButtonVisual() {
    if (!zoomBtn) return;

    if (page.classList.contains('htv-page--overlay-active')) {
      // Overlay open → this becomes a BACK button
      zoomBtn.textContent = '←';
      zoomBtn.classList.add('htv-zoom-toggle--is-back');
      zoomBtn.setAttribute('aria-label', 'Back to grid');
    } else {
      // Grid mode → behave as zoom control (+ / −)
      zoomBtn.classList.remove('htv-zoom-toggle--is-back');
      zoomBtn.setAttribute('aria-label', 'Change grid size');
      zoomBtn.textContent = direction === 1 ? '+' : '−';
    }
  }

  function applyZoom() {
    zoomClasses.forEach(function (cls) {
      page.classList.remove(cls);
    });
    page.classList.add(zoomClasses[currentIndex]);

    page.classList.add('htv-page--zooming');
    if (zoomBtn) zoomBtn.classList.add('htv-zoom-toggle--active');

    window.setTimeout(function () {
      page.classList.remove('htv-page--zooming');
      if (zoomBtn) zoomBtn.classList.remove('htv-zoom-toggle--active');
    }, 350);
  }

  function markPinchZoom() {
    page.setAttribute('data-htv-last-pinch', String(Date.now()));
  }

  function zoomInOneStep() {
    if (currentIndex >= zoomClasses.length - 1) return;
    currentIndex += 1;
    if (currentIndex === zoomClasses.length - 1) {
      direction = -1;
    }
    applyZoom();
    updateZoomButtonVisual();
    markPinchZoom();
  }

  function zoomOutOneStep() {
    if (currentIndex <= 0) return;
    currentIndex -= 1;
    if (currentIndex === 0) {
      direction = 1;
    }
    applyZoom();
    updateZoomButtonVisual();
    markPinchZoom();
  }

  /* ============================================================
   * 4) CATEGORY ICONS (optional nav)
   * ============================================================ */

  var catButtons = document.querySelectorAll('.htv-cat-btn');
  var flashEl = document.querySelector('[data-htv-collection-flash]');
  var filterPanel = document.querySelector('[data-htv-filter-panel]');
  var filterSelect = document.querySelector('[data-htv-filter-select]');
  var filterStock = document.querySelector('[data-htv-filter-stock]');
  var filterLabelEl = document.querySelector('[data-htv-filter-label]');
  var fullscreenBtn = document.querySelector('[data-htv-fullscreen]');
  var loadingMoreEl = document.querySelector('[data-htv-loading-more]');
  var currentFilter = 'all';
  var inStockOnly = false;
  var collectionRenderToken = 1;
  var paginationState = {
    handle: null,
    page: 0,
    loading: false,
    hasMore: true,
    tagsSet: new Set(),
    initialCount: 0
  };
  var prefetchCache = {};
  var prefetchInFlight = {};
  var refreshLazyTrigger = null;
  var loadingMoreCount = 0;
  var categoryLoadTimer = null;
  var handleMap = {
    clothing: 'allteesevermade',
    baseball: 'BASEBALL',
    stickers: 'stickers',
    headwear: 'allheadwearevermade',
    other: 'allaccessoriesevermade'
  };
  var firstCatPlaceholderShown = {
    baseball: false,
    headwear: false,
    other: false
  };
  var catOrder = ['clothing', 'baseball', 'stickers', 'headwear', 'other'];
  var pendingFilterTag = null;
  var pendingFilterCat = null;

  var filterStateByCat = {
    clothing: { filter: 'all', inStock: false },
    baseball: { filter: 'all', inStock: false },
    stickers: { filter: 'all', inStock: false },
    headwear: { filter: 'all', inStock: false },
    other: { filter: 'all', inStock: false }
  };

  // Manual inventory overrides for print-on-demand products.
  // soldOut marks the full product unavailable.
  // sizes can selectively disable size labels later, e.g. ['M', 'XL'].
  var inventoryOverrides = {
    'PLEASE SELL TEE': {
      soldOut: true,
      sizes: []
    },
    'LOVE IS MORE POWERFUL TEE': {
      soldOut: true,
      sizes: []
    },
    'JUST FRIENDS DEVIL TEE': {
      soldOut: true,
      sizes: []
    },
    'BURGER BOY TEE': {
      soldOut: true,
      sizes: []
    },
    'JOEL CHERRY TREE TEE': {
      soldOut: true,
      sizes: []
    },
    'MOM JEANS BEAR TEE': {
      soldOut: true,
      sizes: []
    },
    'MEWTWO TEE': {
      soldOut: true,
      sizes: []
    },
    'midwest-bmo-tee-orange': {
      soldOut: true,
      sizes: []
    }
  };

  function normalizeSizeLabel(value) {
    var raw = String(value || '').trim().toUpperCase();
    var compact = raw.replace(/[\s-]+/g, '');
    if (raw === 'SMALL') return 'S';
    if (raw === 'MEDIUM') return 'M';
    if (raw === 'LARGE') return 'L';
    if (compact === 'XXL' || compact === '2X' || compact === '2XL') return '2XL';
    if (compact === 'XXXL' || compact === '3X' || compact === '3XL') return '3XL';
    if (compact === 'XL') return 'XL';
    if (compact === 'M') return 'M';
    if (compact === 'L') return 'L';
    if (compact === 'S') return 'S';
    if (raw.indexOf('MEDIUM') !== -1) return 'M';
    if (raw.indexOf('LARGE') !== -1) return 'L';
    if (raw.indexOf('SMALL') !== -1) return 'S';
    return raw;
  }

  function isTeeProduct(title) {
    return String(title || '').toUpperCase().indexOf('TEE') !== -1;
  }

  function getDisplaySizeOrder(title, hasAvailableSizes) {
    if (isTeeProduct(title) && hasAvailableSizes) {
      return ['S', 'M', 'L', 'XL', '2XL', '3XL'];
    }
    return ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  }

  function getInventoryOverride(handle, title) {
    var handleKey = String(handle || '').trim().toLowerCase();
    var titleKey = String(title || '').trim().toUpperCase();
    return inventoryOverrides[handleKey] || inventoryOverrides[titleKey] || null;
  }

  function isProductForcedSoldOut(handle, title) {
    var override = getInventoryOverride(handle, title);
    return !!(override && override.soldOut);
  }

  function isSizeForcedSoldOut(handle, title, sizeLabel) {
    var override = getInventoryOverride(handle, title);
    if (!override || !override.sizes || !override.sizes.length) return false;
    var normalized = normalizeSizeLabel(sizeLabel);
    return override.sizes.some(function (size) {
      return normalizeSizeLabel(size) === normalized;
    });
  }

  function getVariantAvailability(handle, title, variant, sizeLabel) {
    if (!variant) return false;
    if (!variant.available) return false;
    if (isProductForcedSoldOut(handle, title)) return false;
    return !isSizeForcedSoldOut(handle, title, sizeLabel || variant.option1 || variant.title);
  }

  function getProductAvailability(handle, title, variants, fallbackAvailable) {
    if (isProductForcedSoldOut(handle, title)) return false;
    if (variants && variants.length) {
      return variants.some(function (variant) {
        return getVariantAvailability(handle, title, variant, variant.option1 || variant.title);
      });
    }
    return !!fallbackAvailable;
  }

  function applyInventoryOverrideToGridItem(item) {
    if (!item) return;
    var handle = item.getAttribute('data-htv-handle') || '';
    var title = item.getAttribute('data-htv-title') || '';
    if (!isProductForcedSoldOut(handle, title)) return;
    item.classList.add('htv-grid__item--sold-out');
    item.setAttribute('data-htv-available', 'false');
  }

  function applyInventoryOverrideToOverlay(root) {
    if (!root) return;
    var handle = root.getAttribute('data-htv-handle') || '';
    var titleEl = root.querySelector('.htv-overlay-product__title');
    var title = titleEl ? titleEl.textContent : '';
    if (!isProductForcedSoldOut(handle, title)) return;
    root.setAttribute('data-htv-available', 'false');
    root.querySelectorAll('.htv-overlay-product__size-pill').forEach(function (pill) {
      pill.classList.add('is-sold-out');
    });
  }

  function resolveCatFromHandle(handle) {
    var found = Object.keys(handleMap).find(function (cat) {
      return handleMap[cat] === handle;
    });
    return found || 'clothing';
  }

  function readParam(params, keys) {
    for (var i = 0; i < keys.length; i += 1) {
      var value = params.get(keys[i]);
      if (value !== null) return value;
    }
    return null;
  }

  function normalizeCatParam(cat) {
    if (!cat) return '';
    var lowered = cat.toLowerCase();
    var match = Object.keys(handleMap).find(function (key) {
      return key.toLowerCase() === lowered;
    });
    return match || '';
  }

  function parseBoolParam(value) {
    if (value === null || value === undefined) return null;
    var lowered = String(value).toLowerCase();
    return ['1', 'true', 'yes', 'on'].indexOf(lowered) !== -1;
  }

  function parseFilterState(raw) {
    if (!raw) return null;
    var result = {};
    var entries = String(raw).split('|');
    entries.forEach(function (entry) {
      if (!entry) return;
      var parts = entry.split(':');
      if (parts.length < 2) return;
      var cat = normalizeCatParam(parts[0]);
      if (!cat) return;
      var payload = parts.slice(1).join(':');
      var tuple = payload.split(',');
      var encodedTag = tuple[0] || 'all';
      var decodedTag = encodedTag;
      try {
        decodedTag = decodeURIComponent(encodedTag);
      } catch (e) {
        decodedTag = encodedTag;
      }
      var parsedStock = parseBoolParam(tuple.length > 1 ? tuple[1] : null);
      result[cat] = {
        filter: decodedTag || 'all',
        inStock: parsedStock !== null ? parsedStock : false
      };
    });
    return Object.keys(result).length ? result : null;
  }

  function parseDeepLinkConfig() {
    if (!window.URLSearchParams) return null;
    var params = new URLSearchParams(window.location.search || '');
    var cat = readParam(params, ['htv_cat', 'cat', 'category']);
    var product = readParam(params, ['htv_product', 'product']);
    var tag = readParam(params, ['htv_tag', 'tag', 'filter']);
    var stock = readParam(params, ['htv_stock', 'stock', 'inStock', 'instock']);
    var stateRaw = readParam(params, ['htv_state', 'htv_filters', 'state', 'filters']);
    var state = parseFilterState(stateRaw);
    var normalizedCat = normalizeCatParam(cat || '');
    var normalizedTag = tag ? String(tag).trim() : null;
    if (normalizedTag && normalizedTag.toLowerCase() === 'all') normalizedTag = 'all';
    var parsedStock = parseBoolParam(stock);

    if (!normalizedCat && !normalizedTag && parsedStock === null && !state && !product) return null;
    return {
      cat: normalizedCat,
      product: product ? String(product).trim() : null,
      tag: normalizedTag,
      inStock: parsedStock,
      state: state
    };
  }

  function serializeFilterState(stateByCat) {
    var parts = [];
    catOrder.forEach(function (cat) {
      var state = stateByCat[cat];
      if (!state) return;
      var tag = state.filter || 'all';
      var encodedTag = tag;
      try {
        encodedTag = encodeURIComponent(tag);
      } catch (e) {
        encodedTag = tag;
      }
      parts.push(cat + ':' + encodedTag + ',' + (state.inStock ? '1' : '0'));
    });
    return parts.join('|');
  }

  function resolveFilterValue(requested, tags) {
    if (!requested) return '';
    var normalized = String(requested).trim();
    if (!normalized) return '';
    if (!tags || !tags.length) return normalized;
    var lowered = normalized.toLowerCase();
    for (var i = 0; i < tags.length; i += 1) {
      var candidate = String(tags[i]);
      if (candidate.toLowerCase() === lowered) return candidate;
    }
    return normalized;
  }

  var currentCat = resolveCatFromHandle(
    page.getAttribute('data-htv-collection-handle')
  );
  var deepLinkConfig = parseDeepLinkConfig();
  var deepLinkSyncActive = !!deepLinkConfig;
  var deepLinkPlaceholderDelay = deepLinkConfig ? 1600 : null;
  var deepLinkPaginationCat = deepLinkConfig
    ? (deepLinkConfig.cat || currentCat)
    : null;
  var baseballFxEnabled = !(
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
  var baseballFxContainer = null;
  var baseballFxInterval = null;
  var baseballFxActiveCount = 0;
  var baseballFxMax = 24;
  var baseballFxWasActive = false;
  updateFilterLabel(currentCat);
  setupGridCarousel();
  if (gridEl) {
    gridEl.querySelectorAll('[data-htv-item]').forEach(applyInventoryOverrideToGridItem);
  }
  if (scroller) {
    scroller.querySelectorAll('[data-htv-overlay-product]').forEach(applyInventoryOverrideToOverlay);
  }

  function ensureBaseballFxContainer() {
    if (!baseballFxEnabled) return null;
    if (baseballFxContainer) return baseballFxContainer;
    baseballFxContainer = document.createElement('div');
    baseballFxContainer.className = 'htv-baseballs';
    document.body.appendChild(baseballFxContainer);
    return baseballFxContainer;
  }

  function clearBaseballFx() {
    if (baseballFxInterval) {
      window.clearInterval(baseballFxInterval);
      baseballFxInterval = null;
    }
    if (baseballFxContainer) {
      baseballFxContainer.classList.remove('is-active');
      baseballFxContainer.innerHTML = '';
    }
    baseballFxActiveCount = 0;
  }

  function spawnBaseball(options) {
    var container = ensureBaseballFxContainer();
    if (!container) return;
    if (baseballFxActiveCount >= baseballFxMax) return;
    baseballFxActiveCount += 1;

    var ball = document.createElement('span');
    ball.className = 'htv-baseball';
    ball.textContent = '⚾️';

    var size = (options && options.size) || (18 + Math.random() * 14);
    var duration = (options && options.duration) || (10 + Math.random() * 7);
    var delay = (options && options.delay) || 0;
    var left = (options && options.left) || (Math.random() * 100);
    var opacity = (options && options.opacity) || (0.65 + Math.random() * 0.3);

    ball.style.left = left + 'vw';
    ball.style.opacity = opacity.toFixed(2);
    ball.style.fontSize = size + 'px';
    ball.style.animationDuration = duration + 's';
    ball.style.animationDelay = delay + 's';

    container.appendChild(ball);

    var cleanup = function () {
      ball.removeEventListener('animationend', cleanup);
      if (ball.parentNode) ball.parentNode.removeChild(ball);
      baseballFxActiveCount = Math.max(0, baseballFxActiveCount - 1);
    };
    ball.addEventListener('animationend', cleanup);
  }

  function burstBaseballs(count) {
    var total = Math.min(typeof count === 'number' ? count : 8, baseballFxMax);
    for (var i = 0; i < total; i += 1) {
      spawnBaseball({
        delay: Math.random() * 0.5,
        duration: 9 + Math.random() * 6,
        size: 16 + Math.random() * 16,
        left: Math.random() * 100,
        opacity: 0.6 + Math.random() * 0.35
      });
    }
  }

  function updateBaseballFxState() {
    if (!baseballFxEnabled) return;
    var shouldRun = currentCat === 'baseball';

    if (!shouldRun) {
      baseballFxWasActive = false;
      clearBaseballFx();
      return;
    }

    var container = ensureBaseballFxContainer();
    if (!container) return;
    container.classList.add('is-active');

    if (!baseballFxInterval) {
      baseballFxInterval = window.setInterval(function () {
        if (document.hidden) return;
        spawnBaseball();
      }, 3200);
    }

    if (!baseballFxWasActive) {
      burstBaseballs(page.classList.contains('htv-page--overlay-active') ? 14 : 10);
    }
    baseballFxWasActive = true;
  }

  function updateDeepLinkUrl() {
    if (!deepLinkSyncActive) return;
    if (!window.URLSearchParams || !window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search || '');
    var activeState = filterStateByCat[currentCat] || { filter: currentFilter, inStock: inStockOnly };
    params.set('htv_cat', currentCat);
    params.set('htv_tag', activeState.filter || 'all');
    params.set('htv_stock', activeState.inStock ? '1' : '0');
    var serialized = serializeFilterState(filterStateByCat);
    if (serialized) {
      params.set('htv_state', serialized);
    } else {
      params.delete('htv_state');
    }
    var query = params.toString();
    var nextUrl =
      window.location.pathname +
      (query ? '?' + query : '') +
      (window.location.hash || '');
    window.history.replaceState({}, '', nextUrl);
  }

  function buildShareUrl(handle) {
    if (!handle) return window.location.href;
    return window.location.origin + '/products/' + encodeURIComponent(handle);
  }

  var htvDebugEnabled = false;
  if (window.URLSearchParams) {
    var debugParams = new URLSearchParams(window.location.search || '');
    htvDebugEnabled = debugParams.get('htv_debug') === '1';
  } else if (window.location && window.location.search) {
    htvDebugEnabled = window.location.search.indexOf('htv_debug=1') !== -1;
  }

  function normalizeString(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback;
    return String(value);
  }

  function normalizeNumber(value, fallback) {
    var num = Number(value);
    if (isNaN(num)) return fallback;
    return num;
  }

  function normalizeViewSource(value) {
    return value === 'grid' || value === 'overlay' ? value : 'grid';
  }

  function normalizeExitReason(value) {
    var allowed = {
      swipe: true,
      back_button: true,
      escape_key: true,
      history_back: true,
      zoom_button: true,
      filter_change: true,
      swipe_close: true
    };
    return allowed[value] ? value : 'swipe';
  }

  function normalizeCategorySource(value) {
    var allowed = {
      click: true,
      drag: true,
      deeplink: true,
      unknown: true
    };
    return allowed[value] ? value : 'unknown';
  }

  function normalizeHtvPayload(eventName, payload) {
    var base = payload || {};
    var fallbackCategory = normalizeString(currentCat, '(unknown)');
    var fallbackHandle = normalizeString(
      page.getAttribute('data-htv-collection-handle'),
      '(unknown)'
    );

    if (eventName === 'htv_product_view') {
      return {
        htv_category: normalizeString(base.htv_category, fallbackCategory),
        htv_collection_handle: normalizeString(base.htv_collection_handle, fallbackHandle),
        htv_product_handle: normalizeString(base.htv_product_handle, '(unknown)'),
        htv_product_title: normalizeString(base.htv_product_title, '(unknown)'),
        htv_product_index: normalizeNumber(base.htv_product_index, -1),
        htv_view_source: normalizeViewSource(base.htv_view_source)
      };
    }

    if (eventName === 'htv_product_dwell') {
      return {
        htv_category: normalizeString(base.htv_category, fallbackCategory),
        htv_collection_handle: normalizeString(base.htv_collection_handle, fallbackHandle),
        htv_product_handle: normalizeString(base.htv_product_handle, '(unknown)'),
        htv_product_title: normalizeString(base.htv_product_title, '(unknown)'),
        htv_product_index: normalizeNumber(base.htv_product_index, -1),
        htv_dwell_ms: normalizeNumber(base.htv_dwell_ms, -1),
        htv_exit_reason: normalizeExitReason(base.htv_exit_reason)
      };
    }

    if (eventName === 'htv_interested_click') {
      return {
        htv_category: normalizeString(base.htv_category, fallbackCategory),
        htv_collection_handle: normalizeString(base.htv_collection_handle, fallbackHandle),
        htv_product_handle: normalizeString(base.htv_product_handle, '(unknown)'),
        htv_product_title: normalizeString(base.htv_product_title, '(unknown)'),
        htv_product_index: normalizeNumber(base.htv_product_index, -1)
      };
    }

    if (eventName === 'htv_category_click') {
      return {
        htv_category: normalizeString(base.htv_category, fallbackCategory),
        htv_collection_handle: normalizeString(base.htv_collection_handle, fallbackHandle)
      };
    }

    if (eventName === 'htv_category_change') {
      return {
        htv_category: normalizeString(base.htv_category, fallbackCategory),
        htv_collection_handle: normalizeString(base.htv_collection_handle, fallbackHandle),
        htv_category_source: normalizeCategorySource(base.htv_category_source)
      };
    }

    return base;
  }

  function pushDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    var normalizedPayload = normalizeHtvPayload(eventName, payload);
    if (htvDebugEnabled && eventName && eventName.indexOf('htv_') === 0) {
      normalizedPayload.debug_mode = true;
      if (window.console && console.log) {
        console.log('[HTV] dataLayer push', eventName, normalizedPayload);
      }
    }
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName
        },
        normalizedPayload
      )
    );
  }

  function getProductMetaByIndex(index) {
    if (!gridEl) return { handle: '', title: '' };
    var item = gridEl.querySelector('[data-htv-item][data-htv-index="' + index + '"]');
    if (!item) return { handle: '', title: '' };
    return {
      handle: item.getAttribute('data-htv-handle') || '',
      title: item.getAttribute('data-htv-title') || ''
    };
  }

  function setActiveCat(cat) {
    catButtons.forEach(function (btn) {
      var btnCat = btn.getAttribute('data-htv-cat');
      var isActive = btnCat === cat;
      btn.classList.toggle('is-active', isActive);
      btn.style.setProperty('--htv-cat-progress', isActive ? '1' : '0');
    });
  }

  function flashCollectionLabel(cat) {
    if (!flashEl) return;
    var label = cat === 'clothing' ? 'Clothing' : cat.charAt(0).toUpperCase() + cat.slice(1);
    flashEl.textContent = label;
    flashEl.classList.remove('is-active');
    void flashEl.offsetHeight;
    flashEl.classList.add('is-active');
    window.clearTimeout(flashEl._htvTimer);
    flashEl._htvTimer = window.setTimeout(function () {
      flashEl.classList.remove('is-active');
    }, 1400);
  }

  function updateFilterLabel(cat) {
    if (!filterLabelEl) return;
    var label = cat === 'clothing' ? 'CLOTHING' : cat.toUpperCase();
    filterLabelEl.textContent = label;
  }

  function updateFilterToggleState() {
    if (!fullscreenBtn) return;
    var isActive = currentFilter !== 'all' || inStockOnly;
    fullscreenBtn.classList.toggle('is-active', isActive);
  }

  function setupGridCarousel() {
    if (!gridEl || (gridEl.closest && gridEl.closest('.htv-grid-carousel'))) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'htv-grid-carousel';
    var track = document.createElement('div');
    track.className = 'htv-grid-track';
    gridEl.parentNode.insertBefore(wrapper, gridEl);
    wrapper.appendChild(track);
    track.appendChild(gridEl);
    var ghost = document.createElement('ul');
    ghost.className = 'htv-grid htv-grid--ghost';
    track.appendChild(ghost);
    gridCarousel = wrapper;
    gridTrack = track;
    ghostGrid = ghost;
    ensurePlaceholderLayer();
  }

  function clearGhostGrid() {
    if (!ghostGrid) return;
    ghostGrid.innerHTML = '';
  }

  function ensureGridPlaceholders(token) {
    if (!gridEl) return;
    var localToken = token || collectionRenderToken;
    function ensure() {
      if (localToken !== collectionRenderToken) return;
      if (!gridEl.children.length) {
        renderGridPlaceholders(CATEGORY_PLACEHOLDER_COUNT);
      }
    }
    ensure();
    window.setTimeout(ensure, 120);
  }

  function startGridLoading(token, category, durationMs) {
    if (!gridEl) return;
    ensurePlaceholderLayer();
    gridLoadingToken = token || collectionRenderToken;
    loadingCategory = category || loadingCategory;
    loadingLogged = false;
    if (gridLoadingTimer) {
      window.clearInterval(gridLoadingTimer);
      gridLoadingTimer = null;
    }
    page.classList.add('htv-grid-loading');
    if (placeholderLayer) placeholderLayer.style.display = 'grid';
    if (placeholderLayer && placeholderLayer.parentNode !== gridTrack) {
      gridTrack.insertBefore(placeholderLayer, gridEl);
    }
    if (gridEl) gridEl.style.opacity = '0';
    var tickCount = 0;
    var maxTicks = 20;
    gridLoadingTimer = window.setInterval(function () {
      if (gridLoadingToken !== collectionRenderToken) {
        stopGridLoading();
        return;
      }
      if (gridEl.querySelectorAll('[data-htv-item]').length) {
        stopGridLoading();
        return;
      }
      if (gridEl.children.length < CATEGORY_PLACEHOLDER_COUNT) {
        renderGridPlaceholders(CATEGORY_PLACEHOLDER_COUNT);
      }
      tickCount += 1;
      if (tickCount >= maxTicks) stopGridLoading();
    }, 120);
    if (!gridEl.children.length) {
      renderGridPlaceholders(CATEGORY_PLACEHOLDER_COUNT);
    }
    var duration = typeof durationMs === 'number' ? durationMs : 2000;
    window.setTimeout(function () {
      if (gridLoadingToken !== collectionRenderToken) return;
      stopGridLoading();
    }, duration);
  }

  function stopGridLoading() {
    if (gridLoadingTimer) {
      window.clearInterval(gridLoadingTimer);
      gridLoadingTimer = null;
    }
    page.classList.remove('htv-grid-loading');
    if (placeholderLayer) placeholderLayer.style.display = 'none';
    if (gridEl) gridEl.style.opacity = '';
    if (loadingCategory && !loadingLogged) {
      console.log('log - ' + loadingCategory + ' loaded');
      loadingLogged = true;
    }
    loadingCategory = null;
  }

  function updateLoadingProgress(category) {
    if (!gridEl) return;
    var count = gridEl.querySelectorAll('[data-htv-item]').length;
    if (count > 0 && !loadingLogged) {
      stopGridLoading();
    }
  }

  function createPlaceholderItem(extraClass) {
    var li = document.createElement('li');
    li.className = 'htv-grid__item htv-grid__item--placeholder' + (extraClass ? ' ' + extraClass : '');
    li.setAttribute('data-htv-placeholder', 'true');
    var imgWrap = document.createElement('div');
    imgWrap.className = 'htv-grid__image-wrap';
    var meta = document.createElement('div');
    meta.className = 'htv-grid__meta';
    var titleSpan = document.createElement('span');
    titleSpan.className = 'htv-grid__title card__heading h5 htv-grid__title--placeholder';
    titleSpan.textContent = ' ';
      meta.appendChild(titleSpan);
    li.appendChild(imgWrap);
    li.appendChild(meta);
    return li;
  }

  function ensurePlaceholderLayer() {
    if (!gridTrack || !gridEl || placeholderLayer) return;
    placeholderLayer = document.createElement('ul');
    placeholderLayer.className = 'htv-grid htv-grid--placeholder-layer';
    for (var i = 0; i < CATEGORY_PLACEHOLDER_COUNT; i += 1) {
      placeholderLayer.appendChild(createPlaceholderItem());
    }
    gridTrack.insertBefore(placeholderLayer, gridEl);
  }


  function renderGhostPlaceholders(count) {
    if (!ghostGrid) return;
    clearGhostGrid();
    for (var i = 0; i < count; i += 1) {
      ghostGrid.appendChild(createPlaceholderItem('htv-grid__item--ghost'));
    }
  }

  function renderGridPlaceholders(count) {
    if (!gridEl) return;
    gridEl.innerHTML = '';
    for (var i = 0; i < count; i += 1) {
      gridEl.appendChild(createPlaceholderItem());
    }
  }

  function promoteGhostToGrid() {
    if (!gridEl || !ghostGrid) return;
    var nodes = Array.prototype.slice.call(ghostGrid.children);
    if (!nodes.length) return;
    gridEl.innerHTML = '';
    nodes.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.classList.remove('htv-grid__item--ghost');
      if (!clone.classList.contains('htv-grid__item--placeholder')) {
        clone.classList.add('htv-grid__item--placeholder');
      }
      clone.setAttribute('data-htv-placeholder', 'true');
      clone.removeAttribute('data-htv-item');
      clone.removeAttribute('data-htv-index');
      clone.removeAttribute('data-htv-handle');
      clone.removeAttribute('data-htv-title');
      clone.removeAttribute('data-htv-tags');
      clone.removeAttribute('data-htv-available');
      gridEl.appendChild(clone);
    });
  }

  function appendGhostGridItem(prod) {
    if (!ghostGrid) return;
    var li = document.createElement('li');
    li.className = 'htv-grid__item htv-grid__item--ghost';

    var link = document.createElement('div');
    link.className = 'htv-grid__link';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'htv-grid__image-wrap';

    var imgSrc = prod.images && prod.images.length ? prod.images[0].src : null;
    if (imgSrc) {
      var img = document.createElement('img');
      img.className = 'htv-grid__image htv-lazy-img';
      img.loading = 'lazy';
      img.src = sizedImage(imgSrc, 900);
      img.alt = prod.title || '';
      setupLazyImage(img);
      imgWrap.appendChild(img);
    }

    var meta = document.createElement('div');
    meta.className = 'htv-grid__meta';
    var titleSpan = document.createElement('span');
    titleSpan.className = 'htv-grid__title card__heading h5';
    titleSpan.textContent = prod.title || '';
    meta.appendChild(titleSpan);

    link.appendChild(imgWrap);
    link.appendChild(meta);
    li.appendChild(link);
    ghostGrid.appendChild(li);
  }

  function renderGhostFromProducts(products, count) {
    if (!ghostGrid) return;
    clearGhostGrid();
    var limit = count || CATEGORY_PLACEHOLDER_COUNT;
    products.slice(0, limit).forEach(function (prod) {
      appendGhostGridItem(prod);
    });
  }

  function resetCategoryProgress(activeCat) {
    catButtons.forEach(function (btn) {
      var btnCat = btn.getAttribute('data-htv-cat');
      btn.style.setProperty('--htv-cat-progress', btnCat === activeCat ? '1' : '0');
    });
  }

  function clearRenderedProducts() {
    if (gridEl) {
      gridEl.querySelectorAll('li.htv-grid__item').forEach(function (li) {
        li.remove();
      });
    }
    if (scroller) {
      scroller.querySelectorAll('[data-htv-overlay-product]').forEach(function (sec) {
        sec.remove();
      });
    }
  }

  function parseTags(raw) {
    if (!raw) return [];
    return raw
      .split('|')
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
  }

  function collectTagsFromDom() {
    if (!gridEl) return [];
    var tags = [];
    gridEl.querySelectorAll('[data-htv-item]').forEach(function (item) {
      tags = tags.concat(parseTags(item.getAttribute('data-htv-tags')));
    });
    return Array.from(new Set(tags));
  }

  function updateFilterOptions(tags) {
    if (!filterSelect) return;
    var sorted = tags.slice();
    var pendingTag = null;

    if (pendingFilterTag && pendingFilterCat === currentCat) {
      pendingTag = resolveFilterValue(pendingFilterTag, sorted);
      if (pendingTag && pendingTag !== 'all' && sorted.indexOf(pendingTag) === -1) {
        sorted.push(pendingTag);
      }
      if (pendingTag) {
        currentFilter = pendingTag;
        filterStateByCat[currentCat] = filterStateByCat[currentCat] || { filter: 'all', inStock: false };
        filterStateByCat[currentCat].filter = currentFilter;
      }
      pendingFilterTag = null;
      pendingFilterCat = null;
    }

    var resolvedCurrent = resolveFilterValue(currentFilter, sorted);
    if (resolvedCurrent && resolvedCurrent !== currentFilter) {
      currentFilter = resolvedCurrent;
      filterStateByCat[currentCat] = filterStateByCat[currentCat] || { filter: 'all', inStock: false };
      filterStateByCat[currentCat].filter = currentFilter;
    }

    if (currentFilter && currentFilter !== 'all' && sorted.indexOf(currentFilter) === -1) {
      sorted.push(currentFilter);
    }

    sorted.sort();
    filterSelect.innerHTML = '<option value="all">ALL</option>' +
      sorted.map(function (tag) {
        return '<option value="' + tag.replace(/"/g, '&quot;') + '">' + tag + '</option>';
      }).join('');
  }

  function applyFilters(options) {
    if (!gridEl || !scroller) return;
    var keepOverlay = options && options.keepOverlay;
    var items = gridEl.querySelectorAll('[data-htv-item]');
    items.forEach(function (item) {
      var tags = parseTags(item.getAttribute('data-htv-tags'));
      var availableAttr = item.getAttribute('data-htv-available');
      var available = availableAttr === 'true' || !item.classList.contains('htv-grid__item--sold-out');
      var matchesTag = currentFilter === 'all' || tags.indexOf(currentFilter) !== -1;
      var matchesStock = !inStockOnly || available;
      item.classList.toggle('htv-filter-hidden', !(matchesTag && matchesStock));
    });

    var overlays = scroller.querySelectorAll('[data-htv-overlay-product]');
    overlays.forEach(function (section) {
      var tags = parseTags(section.getAttribute('data-htv-tags'));
      var availableAttr = section.getAttribute('data-htv-available');
      var available = availableAttr === 'true';
      var matchesTag = currentFilter === 'all' || tags.indexOf(currentFilter) !== -1;
      var matchesStock = !inStockOnly || available;
      section.classList.toggle('htv-filter-hidden', !(matchesTag && matchesStock));
    });

    updateFilterToggleState();

    if (!keepOverlay && page.classList.contains('htv-page--overlay-active')) {
      closeOverlay(false, true, 'filter_change');
    }
  }

  function setLoadingMore(isLoading) {
    if (!loadingMoreEl) return;
    if (isLoading) {
      loadingMoreCount += 1;
    } else {
      loadingMoreCount = Math.max(0, loadingMoreCount - 1);
    }
    loadingMoreEl.classList.toggle('is-active', loadingMoreCount > 0);
    loadingMoreEl.setAttribute('aria-hidden', loadingMoreCount > 0 ? 'false' : 'true');
  }

  function initPagination(handle, initialCount) {
    paginationState = {
      handle: handle,
      page: 0,
      loading: false,
      hasMore: true,
      tagsSet: new Set(),
      initialCount: initialCount || 0
    };
  }

  function updateFilterSelectValue() {
    if (!filterSelect) return;
    filterSelect.value = currentFilter || 'all';
  }

  function fetchCollectionPage(pageNum, skipCount, options) {
    if (!paginationState.handle || paginationState.loading) return Promise.resolve(false);
    if (pageNum > 1 && !paginationState.hasMore) return Promise.resolve(false);

    var token = collectionRenderToken;
    var handle = paginationState.handle;
    paginationState.loading = true;
    setLoadingMore(true);

    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + pageNum)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (token !== collectionRenderToken) return false;
        if (page.getAttribute('data-htv-collection-handle') !== handle) return false;
        if (!data || !data.products || !data.products.length) {
          paginationState.hasMore = false;
          return false;
        }

        paginationState.page = pageNum;
        paginationState.hasMore = data.products.length === 250;
        data.products.forEach(function (p) {
          (p.tags || []).forEach(function (t) {
            paginationState.tagsSet.add(t);
          });
        });
        if (pageNum === 1) {
          prefetchCache[handle] = {
            products: data.products,
            tags: Array.from(paginationState.tagsSet),
            partial: false,
            pages: {}
          };
        }

        updateFilterOptions(Array.from(paginationState.tagsSet));
        updateFilterSelectValue();

        var renderList = data.products;
        if (pageNum === 1 && skipCount) {
          renderList = data.products.slice(skipCount);
        }
        var indexOffset = gridEl ? gridEl.querySelectorAll('[data-htv-item]').length : 0;
        renderProductsInChunks(renderList, indexOffset, token, 50, options);
        applyFilters(options);
        if (pageNum === 1 && deepLinkPaginationCat && currentCat === deepLinkPaginationCat) {
          ensureActivePagination(token);
        }
        return true;
      })
      .catch(function (err) {
        console.error('HTV collection page error', err);
        return false;
      })
      .finally(function () {
        paginationState.loading = false;
        setLoadingMore(false);
      });
  }

  function renderPrefetched(handle, token, options) {
    var cached = prefetchCache[handle];
    if (!cached || token !== collectionRenderToken) return false;
    var keepPlaceholders = options && options.keepPlaceholders;
    if (!keepPlaceholders) {
      clearRenderedProducts();
    } else {
      if (gridEl) {
        gridEl.querySelectorAll('[data-htv-item]').forEach(function (item) {
          item.remove();
        });
      }
      if (scroller) {
        scroller.querySelectorAll('[data-htv-overlay-product]').forEach(function (sec) {
          sec.remove();
        });
      }
    }
    initPagination(handle, 0);
    if (cached.partial) {
      paginationState.page = 0;
      paginationState.initialCount = cached.products.length;
      paginationState.hasMore = true;
    } else {
      paginationState.page = 1;
      paginationState.hasMore = cached.products.length === 250;
    }
    paginationState.tagsSet = new Set(cached.tags || []);
    updateFilterOptions(Array.from(paginationState.tagsSet));
    updateFilterSelectValue();
    renderProductsInChunks(cached.products, 0, token, CATEGORY_PLACEHOLDER_COUNT, { keepOverlay: true });
    applyFilters();
    return true;
  }

  function prefetchCategory(handle, onReady, options) {
    if (!handle) return;
    var limit = options && options.limit ? options.limit : 250;
    var page = options && options.page ? options.page : 1;
    var inflightKey = handle + ':' + page + ':' + limit;

    if (page === 1 && prefetchCache[handle] && prefetchCache[handle].products && prefetchCache[handle].products.length) {
      if (typeof onReady === 'function') onReady(prefetchCache[handle]);
      return Promise.resolve(prefetchCache[handle]);
    }

    if (prefetchInFlight[inflightKey]) return Promise.resolve(null);
    prefetchInFlight[inflightKey] = true;

    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit + '&page=' + page)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.products) return;
        var tags = [];
        data.products.forEach(function (p) {
          tags = tags.concat(p.tags || []);
        });
    if (!prefetchCache[handle]) {
      prefetchCache[handle] = { products: [], tags: [], pages: {}, partial: false };
    }

    if (page === 1) {
      prefetchCache[handle].products = data.products;
      prefetchCache[handle].tags = Array.from(new Set(tags));
      prefetchCache[handle].partial = limit < 250;
    } else {
      prefetchCache[handle].pages[page] = data.products;
    }
        if (typeof onReady === 'function') onReady(prefetchCache[handle]);
      })
      .catch(function (err) {
        console.error('HTV prefetch error', err);
      })
      .finally(function () {
        prefetchInFlight[inflightKey] = false;
      });
  }

  function prefetchNextCategory(cat) {
    var idx = catOrder.indexOf(cat);
    if (idx === -1) return;
    var nextCat = catOrder[(idx + 1) % catOrder.length];
    var nextHandle = handleMap[nextCat];
    if (!nextHandle) return;
    window.setTimeout(function () {
      prefetchCategory(nextHandle, null, { limit: CATEGORY_PLACEHOLDER_COUNT });
    }, 1200);
  }

  function loadAllRemainingPages() {
    if (!paginationState.handle) return;
    var nextPage = paginationState.page === 0 ? 1 : paginationState.page + 1;
    var skipCount = paginationState.page === 0 ? paginationState.initialCount : 0;
    fetchCollectionPage(nextPage, skipCount, { keepOverlay: true }).then(function (didLoad) {
      if (!didLoad) return;
      if (paginationState.hasMore) {
        loadAllRemainingPages();
      }
    });
  }

  function ensureActivePagination(token) {
    var allowDeepLink =
      deepLinkPaginationCat && currentCat === deepLinkPaginationCat;
    if (!prefetchSequenceCompleted && !userHasScrolled && !allowDeepLink) return;
    if (token && token !== collectionRenderToken) return;
    if (!paginationState.handle) return;
    if (!paginationState.hasMore) return;
    if (paginationState.loading) {
      window.setTimeout(function () {
        ensureActivePagination(token);
      }, 300);
      return;
    }
    if (allowDeepLink) {
      deepLinkPaginationCat = null;
    }
    loadAllRemainingPages();
  }

  function scheduleCategoryLoad(handle, token) {
    if (categoryLoadTimer) {
      window.clearTimeout(categoryLoadTimer);
    }
    var delay = deepLinkPlaceholderDelay !== null
      ? deepLinkPlaceholderDelay
      : CATEGORY_PLACEHOLDER_DELAY;
    deepLinkPlaceholderDelay = null;
    categoryLoadTimer = window.setTimeout(function () {
      if (token !== collectionRenderToken) return;
      if (paginationState.page > 0 || paginationState.loading) {
        categoryLoadTimer = null;
        return;
      }
      if (!renderPrefetched(handle, token, { keepPlaceholders: true })) {
        fetchCollectionPage(1, 0);
      }
      ensureActivePagination(token);
      categoryLoadTimer = null;
    }, delay);
  }

  function startPrefetchSequence() {
    if (prefetchSequenceStarted) return;
    prefetchSequenceStarted = true;

    var teesHandle = handleMap[catOrder[0]];
    var baseballHandle = handleMap[catOrder[1]];
    var stickersHandle = handleMap[catOrder[2]];
    var headwearHandle = handleMap[catOrder[3]];
    var otherHandle = handleMap[catOrder[4]];

    var chain = Promise.resolve();

    if (baseballHandle) {
      chain = chain.then(function () {
        return prefetchCategory(baseballHandle, null, { limit: CATEGORY_PLACEHOLDER_COUNT });
      });
    }

    if (stickersHandle) {
      chain = chain.then(function () {
        return prefetchCategory(stickersHandle, null, { limit: CATEGORY_PLACEHOLDER_COUNT });
      });
    }

    if (teesHandle) {
      chain = chain.then(function () {
        return prefetchCategory(teesHandle, null, { limit: CATEGORY_PLACEHOLDER_COUNT, page: 2 });
      });
    }

    if (headwearHandle) {
      chain = chain.then(function () {
        return prefetchCategory(headwearHandle, null, { limit: CATEGORY_PLACEHOLDER_COUNT });
      });
    }

    if (otherHandle) {
      chain = chain.then(function () {
        return prefetchCategory(otherHandle, null, { limit: CATEGORY_PLACEHOLDER_COUNT });
      });
    }

    chain.finally(function () {
      prefetchSequenceCompleted = true;
      if (typeof enableAutoLoad === 'function') enableAutoLoad();
      if (typeof requestActivePagination === 'function') {
        requestActivePagination();
      }
    });
  }

  function loadCollection(handle, cat, options) {
    if (!handle) return;
    var currentHandle = page.getAttribute('data-htv-collection-handle');
    var source = options && options.source ? options.source : 'unknown';
    if (currentHandle === handle) {
      setActiveCat(cat);
      currentCat = cat;
      var state = filterStateByCat[currentCat] || { filter: 'all', inStock: false };
      currentFilter = state.filter;
      inStockOnly = state.inStock;
      updateFilterLabel(currentCat);
      updateFilterOptions(Array.from(paginationState.tagsSet).length ? Array.from(paginationState.tagsSet) : collectTagsFromDom());
      updateFilterSelectValue();
      if (filterStock) filterStock.checked = inStockOnly;
      applyFilters();
      flashCollectionLabel(cat);
      updateDeepLinkUrl();
      prefetchNextCategory(cat);
      updateBaseballFxState();
      return;
    }

    pushDataLayer('htv_category_change', {
      htv_category: cat,
      htv_collection_handle: handle || '',
      htv_category_source: source
    });

    collectionRenderToken += 1;
    page.setAttribute('data-htv-collection-handle', handle);
    setActiveCat(cat);
    currentCat = cat;
    var newState = filterStateByCat[currentCat] || { filter: 'all', inStock: false };
    currentFilter = newState.filter;
    inStockOnly = newState.inStock;
    updateFilterLabel(currentCat);
    if (filterSelect) filterSelect.value = currentFilter;
    if (filterStock) filterStock.checked = inStockOnly;
    flashCollectionLabel(cat);
    updateDeepLinkUrl();
    updateBaseballFxState();

    var requestToken = collectionRenderToken;
    if (categoryLoadTimer) {
      window.clearTimeout(categoryLoadTimer);
      categoryLoadTimer = null;
    }

    var preserveGrid = options && options.preserveGrid;

    if (!preserveGrid) {
      clearRenderedProducts();
      startGridLoading(requestToken);
    }
    if (loadingMoreEl) {
      loadingMoreEl.classList.remove('is-active');
      loadingMoreEl.setAttribute('aria-hidden', 'true');
      loadingMoreCount = 0;
    }
    if (prefetchCache[handle] && prefetchCache[handle].products && prefetchCache[handle].products.length) {
      initPagination(handle, 0);
      updateFilterOptions([]);
      updateFilterSelectValue();
      renderPrefetched(handle, requestToken, { keepPlaceholders: preserveGrid });
      ensureActivePagination(requestToken);
      if (prefetchSequenceStarted && typeof requestActivePagination === 'function') {
        requestActivePagination();
      }
    } else {
      if (preserveGrid) {
        startGridLoading(requestToken);
      }
      initPagination(handle, 0);
      updateFilterOptions([]);
      updateFilterSelectValue();
      prefetchCategory(handle);
      scheduleCategoryLoad(handle, requestToken);
    }
    prefetchNextCategory(cat);
  }

  function applyDeepLinkConfig(config) {
    if (!config) return false;
    var targetCat = config.cat || currentCat;
    var targetHandle = handleMap[targetCat];
    var targetProduct = config.product;
    if (deepLinkSyncActive) {
      deepLinkPaginationCat = targetCat;
    }
    if (config.state) {
      Object.keys(config.state).forEach(function (cat) {
        var entry = config.state[cat];
        if (!entry) return;
        filterStateByCat[cat] = filterStateByCat[cat] || { filter: 'all', inStock: false };
        filterStateByCat[cat].filter = entry.filter || 'all';
        filterStateByCat[cat].inStock = !!entry.inStock;
      });
    }

    var state = filterStateByCat[targetCat] || { filter: 'all', inStock: false };

    if (config.tag) {
      pendingFilterTag = config.tag;
      pendingFilterCat = targetCat;
      state.filter = config.tag;
    }
    if (config.inStock !== null) {
      state.inStock = !!config.inStock;
    }
    filterStateByCat[targetCat] = state;

    if (targetCat === currentCat || !targetHandle) {
      currentFilter = state.filter || 'all';
      inStockOnly = state.inStock;
      if (filterStock) filterStock.checked = inStockOnly;
      updateFilterOptions(collectTagsFromDom());
      updateFilterSelectValue();
      applyFilters();
      deepLinkPlaceholderDelay = null;
      updateDeepLinkUrl();
      if (targetProduct) {
        waitForOverlayByHandle(targetProduct, collectionRenderToken, 30);
      }
      return true;
    }

    loadCollection(targetHandle, targetCat, { source: 'deeplink' });
    if (targetProduct) {
      waitForOverlayByHandle(targetProduct, collectionRenderToken, 30);
    }
    return true;
  }

  catButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      markGridInteraction();
      var cat = btn.getAttribute('data-htv-cat');
      var handle = handleMap[cat];
      console.log('log - ' + cat + ' selected');
      loadingCategory = cat;
      var shouldShowPlaceholders = (cat === 'baseball' || cat === 'headwear' || cat === 'other') && !firstCatPlaceholderShown[cat];
      pushDataLayer('htv_category_click', {
        htv_category: cat,
        htv_collection_handle: handle || ''
      });
      try {
        window.dispatchEvent(new CustomEvent('htv:category-change', { detail: { category: cat } }));
      } catch (e) {}
      loadCollection(handle, cat, { source: 'click' });
      startGridLoading(collectionRenderToken, cat, 2000);
      if (shouldShowPlaceholders) {
        firstCatPlaceholderShown[cat] = true;
        var token = collectionRenderToken;
        window.setTimeout(function () {
          if (token !== collectionRenderToken) return;
          if (gridEl && !gridEl.querySelectorAll('[data-htv-item]').length) {
            renderGridPlaceholders(CATEGORY_PLACEHOLDER_COUNT);
          }
        }, 0);
        window.setTimeout(function () {
          if (token !== collectionRenderToken) return;
          if (gridEl && !gridEl.querySelectorAll('[data-htv-item]').length) {
            renderGridPlaceholders(CATEGORY_PLACEHOLDER_COUNT);
          }
        }, 2000);
      }
    });
  });

  updateFilterOptions(collectTagsFromDom());
  updateFilterSelectValue();
  var deepLinkApplied = applyDeepLinkConfig(deepLinkConfig);
  if (!deepLinkApplied) {
    applyFilters();
  }

  if (fullscreenBtn) {
    fullscreenBtn.addEventListener('click', function () {
      markGridInteraction();
      flashCollectionLabel(currentCat);
      if (filterPanel) {
        filterPanel.classList.toggle('is-open');
        filterPanel.setAttribute('aria-hidden', filterPanel.classList.contains('is-open') ? 'false' : 'true');
      }
      loadAllRemainingPages();
    });
    updateFilterToggleState();
  }

  if (filterSelect) {
    filterSelect.addEventListener('change', function () {
      markGridInteraction();
      currentFilter = filterSelect.value || 'all';
      filterStateByCat[currentCat] = filterStateByCat[currentCat] || { filter: 'all', inStock: false };
      filterStateByCat[currentCat].filter = currentFilter;
      applyFilters();
      updateDeepLinkUrl();
    });
  }

  if (filterStock) {
    filterStock.addEventListener('change', function () {
      markGridInteraction();
      inStockOnly = !!filterStock.checked;
      filterStateByCat[currentCat] = filterStateByCat[currentCat] || { filter: 'all', inStock: false };
      filterStateByCat[currentCat].inStock = inStockOnly;
      applyFilters();
      updateDeepLinkUrl();
    });
  }

  document.addEventListener('click', function (evt) {
    if (!filterPanel || !fullscreenBtn) return;
    var isToggle = fullscreenBtn.contains(evt.target);
    var isPanel = filterPanel.contains(evt.target);
    if (!isToggle && !isPanel) {
      filterPanel.classList.remove('is-open');
      filterPanel.setAttribute('aria-hidden', 'true');
    }
  });

  // Drag left/right on grid view to reveal categories
  (function enableCategoryDrag() {
    if (!gridCarousel || !gridTrack || !ghostGrid) return;

    var startX = 0;
    var startY = 0;
    var dragging = false;
    var dragDir = 0;
    var dragWidth = 0;
    var baseOffset = 0;
    var dragCat = null;
    var dragHandle = null;
    var tutorialShown = false;
    var wheelDelta = 0;
    var wheelLock = false;
    var wheelTimer = null;
    var lastWheelTrigger = 0;
    var wheelStartTime = 0;
    var wheelDir = 0;
    var wheelActive = false;
    var mouseDown = false;
    var mouseVerticalDragging = false;
    var mouseStartScrollY = 0;

    function getAdjacentCat(dir) {
      var currentIdx = catOrder.indexOf(currentCat);
      if (currentIdx === -1) currentIdx = 0;
      var nextIdx = (currentIdx + dir + catOrder.length) % catOrder.length;
      return catOrder[nextIdx];
    }

    function updateProgress(current, target, progress) {
      catButtons.forEach(function (btn) {
        var btnCat = btn.getAttribute('data-htv-cat');
        var value = 0;
        if (btnCat === current) value = Math.max(0, 1 - progress);
        if (btnCat === target) value = Math.max(0, progress);
        btn.style.setProperty('--htv-cat-progress', String(value));
      });
    }

    function prepareGhost(cat, handle, dir, allowProducts) {
      if (!ghostGrid || !gridTrack || !gridEl) return;
      dragCat = cat;
      dragHandle = handle;
      dragWidth = gridCarousel.clientWidth || gridEl.clientWidth || 1;

      if (dir === -1) {
        if (ghostGrid.parentNode !== gridTrack || ghostGrid.nextSibling !== gridEl) {
          gridTrack.insertBefore(ghostGrid, gridEl);
        }
        baseOffset = -dragWidth;
      } else {
        if (ghostGrid.parentNode !== gridTrack || ghostGrid.previousSibling !== gridEl) {
          gridTrack.appendChild(ghostGrid);
        }
        baseOffset = 0;
      }

      gridTrack.style.transition = 'none';
      gridTrack.style.transform = 'translateX(' + baseOffset + 'px)';

      if (allowProducts && prefetchCache[handle]) {
        renderGhostFromProducts(prefetchCache[handle].products, CATEGORY_PLACEHOLDER_COUNT);
        return;
      }

      renderGhostPlaceholders(CATEGORY_PLACEHOLDER_COUNT);
      if (allowProducts) {
        prefetchCategory(handle, function (cache) {
          if (dragging || wheelActive) return;
          if (dragCat !== cat || !cache) return;
          renderGhostFromProducts(cache.products, CATEGORY_PLACEHOLDER_COUNT);
        });
      } else {
        prefetchCategory(handle);
      }
    }

    function resetDragState() {
      dragging = false;
      dragDir = 0;
      dragCat = null;
      dragHandle = null;
      baseOffset = 0;
    }

    function resetWheelState() {
      wheelActive = false;
      wheelDelta = 0;
      wheelStartTime = 0;
      wheelDir = 0;
      window.clearTimeout(wheelTimer);
      wheelTimer = null;
    }

    function completeTransition() {
      var finalOffset = dragDir === 1 ? baseOffset - dragWidth : baseOffset + dragWidth;
      gridTrack.style.transition = 'transform 0.35s ease';
      gridTrack.style.transform = 'translateX(' + finalOffset + 'px)';

      var handled = false;
      var onDone = function () {
        if (handled) return;
        handled = true;
        gridTrack.removeEventListener('transitionend', onDone);
        promoteGhostToGrid();
        loadCollection(dragHandle, dragCat, { preserveGrid: true, source: 'drag' });
        window.setTimeout(resetCarouselPosition, 80);
        resetDragState();
        wheelLock = false;
      };
      gridTrack.addEventListener('transitionend', onDone);
    }

    function resetCarouselPosition() {
      if (!gridTrack || !gridEl || !ghostGrid) return;
      gridTrack.style.transition = 'none';
      gridTrack.style.transform = 'translateX(0px)';
      if (ghostGrid.parentNode === gridTrack && ghostGrid.previousSibling !== gridEl) {
        gridTrack.appendChild(ghostGrid);
      }
      clearGhostGrid();
      resetCategoryProgress(currentCat);
    }

    var tutorialTimer = null;

    function runPeekTutorial() {
      if (tutorialShown) return;
      if (gridInteracted) return;
      if (page.classList.contains('htv-page--overlay-active')) return;
      var nextCat = getAdjacentCat(1);
      var nextHandle = handleMap[nextCat];
      if (!nextHandle) return;

      tutorialShown = true;
      showSwipeHint();
      prepareGhost(nextCat, nextHandle, 1, true);

      var peekOffset = -dragWidth * 0.25;
      gridTrack.style.transition = 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
      gridTrack.style.transform = 'translateX(' + peekOffset + 'px)';
      updateProgress(currentCat, nextCat, 0.25);

      window.setTimeout(function () {
        gridTrack.style.transition = 'transform 0.6s ease';
        gridTrack.style.transform = 'translateX(0px)';
        updateProgress(currentCat, nextCat, 0);
        window.setTimeout(resetCarouselPosition, 600);
      }, 1200);
    }

    function schedulePeekTutorial(delay) {
      if (tutorialShown) return;
      if (gridInteracted) return;
      if (tutorialTimer) {
        window.clearTimeout(tutorialTimer);
        tutorialTimer = null;
      }
      if (delay && delay > 0) {
        tutorialTimer = window.setTimeout(function () {
          tutorialTimer = null;
          runPeekTutorial();
        }, delay);
        return;
      }
      runPeekTutorial();
    }

    postScrollTutorial = function () {
      if (tutorialShown || gridInteracted) return;
      if (page.classList.contains('htv-page--overlay-active')) return;
      schedulePeekTutorial(400);
    };

    function waitForInitialGrid(tutorialDelay) {
      if (!gridEl) return;
      var minCount = CATEGORY_PLACEHOLDER_COUNT;
      var checkReady = function () {
        return gridEl.querySelectorAll('[data-htv-item]').length >= minCount;
      };

      if (checkReady()) {
        startPrefetchSequence();
        scheduleAutoScrollHint(tutorialDelay);
        return;
      }

      var observer = new MutationObserver(function () {
        if (!checkReady()) return;
        observer.disconnect();
        startPrefetchSequence();
        scheduleAutoScrollHint(tutorialDelay);
      });
      observer.observe(gridEl, { childList: true });
      window.setTimeout(function () {
        observer.disconnect();
        startPrefetchSequence();
        scheduleAutoScrollHint(tutorialDelay);
      }, 4500);
    }

    gridCarousel.addEventListener(
      'touchstart',
      function (e) {
        markGridInteraction();
        if (page.classList.contains('htv-page--overlay-active')) return;
        if (!e.touches || e.touches.length !== 1) return;
        var lastPinch = parseInt(page.getAttribute('data-htv-last-pinch'), 10) || 0;
        if (Date.now() - lastPinch < 500) return;
        var t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        dragging = false;
        dragDir = 0;
      },
      { passive: true }
    );

    gridCarousel.addEventListener(
      'touchmove',
      function (e) {
        if (page.classList.contains('htv-page--overlay-active')) return;
        if (!e.touches || e.touches.length !== 1) return;
        var t = e.touches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;

        if (!dragging) {
          if (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          dragDir = dx < 0 ? 1 : -1;
          var targetCat = getAdjacentCat(dragDir);
          var targetHandle = handleMap[targetCat];
          if (!targetHandle) return;
          dragging = true;
          prepareGhost(targetCat, targetHandle, dragDir, true);
        }

        if (!dragging) return;
        e.preventDefault();
        var offset = baseOffset + dx;
        var minOffset = baseOffset - dragWidth;
        var maxOffset = baseOffset + dragWidth;
        if (offset < minOffset) offset = minOffset;
        if (offset > maxOffset) offset = maxOffset;
        gridTrack.style.transform = 'translateX(' + offset + 'px)';
        var progress = Math.min(1, Math.abs(dx) / dragWidth);
        updateProgress(currentCat, dragCat, progress);
      },
      { passive: false }
    );

    gridCarousel.addEventListener(
      'touchend',
      function (e) {
        if (!dragging) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var threshold = dragWidth * 0.25;
        var commit = Math.abs(dx) > threshold;

        if (!commit) {
          gridTrack.style.transition = 'transform 0.3s ease';
          gridTrack.style.transform = 'translateX(' + baseOffset + 'px)';
          resetCategoryProgress(currentCat);
          window.setTimeout(resetCarouselPosition, 320);
          resetDragState();
          return;
        }

        completeTransition();
      },
      { passive: true }
    );

    function handleMouseMove(e) {
      if (!mouseDown) return;
      if (page.classList.contains('htv-page--overlay-active')) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!dragging && !mouseVerticalDragging) {
        var absX = Math.abs(dx);
        var absY = Math.abs(dy);
        if (absX < 8 && absY < 8) return;

        if (absX >= absY * 1.2) {
          dragDir = dx < 0 ? 1 : -1;
          var targetCat = getAdjacentCat(dragDir);
          var targetHandle = handleMap[targetCat];
          if (!targetHandle) return;
          dragging = true;
          suppressGridClick = true;
          document.body.classList.add('htv-dragging');
          prepareGhost(targetCat, targetHandle, dragDir, true);
        } else if (absY >= absX * 1.2) {
          mouseVerticalDragging = true;
          suppressGridClick = true;
          document.body.classList.add('htv-dragging');
        } else {
          return;
        }
      }

      if (dragging) {
        e.preventDefault();
        var offset = baseOffset + dx;
        var minOffset = baseOffset - dragWidth;
        var maxOffset = baseOffset + dragWidth;
        if (offset < minOffset) offset = minOffset;
        if (offset > maxOffset) offset = maxOffset;
        gridTrack.style.transform = 'translateX(' + offset + 'px)';
        var progress = Math.min(1, Math.abs(dx) / dragWidth);
        updateProgress(currentCat, dragCat, progress);
        return;
      }

      if (mouseVerticalDragging) {
        e.preventDefault();
        window.scrollTo(0, mouseStartScrollY - dy);
      }
    }

    function handleMouseUp(e) {
      if (!mouseDown) return;
      mouseDown = false;
      document.body.classList.remove('htv-dragging');
      if (dragging) {
        var dx = e.clientX - startX;
        var threshold = dragWidth * 0.25;
        var commit = Math.abs(dx) > threshold;

        if (!commit) {
          gridTrack.style.transition = 'transform 0.3s ease';
          gridTrack.style.transform = 'translateX(' + baseOffset + 'px)';
          resetCategoryProgress(currentCat);
          window.setTimeout(resetCarouselPosition, 320);
          resetDragState();
        } else {
          completeTransition();
        }
      }

      mouseVerticalDragging = false;
      if (suppressGridClick) {
        window.setTimeout(function () {
          suppressGridClick = false;
        }, 120);
      }
    }

    gridCarousel.addEventListener(
      'mousedown',
      function (e) {
        markGridInteraction();
        if (page.classList.contains('htv-page--overlay-active')) return;
        if (e.button !== 0) return;
        mouseDown = true;
        mouseVerticalDragging = false;
        mouseStartScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        startX = e.clientX;
        startY = e.clientY;
        dragging = false;
        dragDir = 0;
        document.body.classList.add('htv-dragging');
        e.preventDefault();
      },
      { passive: false }
    );

    window.addEventListener('mousemove', handleMouseMove, { passive: false });
    window.addEventListener('mouseup', handleMouseUp, { passive: true });
    gridCarousel.addEventListener('mouseleave', handleMouseUp, { passive: true });
    gridCarousel.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    gridCarousel.addEventListener(
      'wheel',
      function (e) {
        markGridInteraction();
        if (page.classList.contains('htv-page--overlay-active')) return;
        if (dragging && !wheelActive) return;
        if (wheelLock) {
          e.preventDefault();
          return;
        }
        if (Date.now() - lastWheelTrigger < 700) {
          e.preventDefault();
          return;
        }

        var horizontalIntent = Math.abs(e.deltaX) > Math.abs(e.deltaY);
        if (!horizontalIntent && !e.shiftKey) return;

        var delta = horizontalIntent ? e.deltaX : e.deltaY;
        if (Math.abs(delta) < 1) return;

        e.preventDefault();
        if (!wheelStartTime) {
          wheelStartTime = Date.now();
          wheelDir = delta > 0 ? 1 : -1;
        }
        wheelDelta += delta;
        window.clearTimeout(wheelTimer);
        wheelTimer = window.setTimeout(function () {
          if (!wheelActive) return;
          if (Math.abs(wheelDelta) < 110) {
            gridTrack.style.transition = 'transform 0.3s ease';
            gridTrack.style.transform = 'translateX(' + baseOffset + 'px)';
            resetCategoryProgress(currentCat);
            window.setTimeout(resetCarouselPosition, 320);
            resetWheelState();
          }
        }, 180);

        if (!wheelActive) {
          var targetCat = getAdjacentCat(wheelDir || (wheelDelta > 0 ? 1 : -1));
          var targetHandle = handleMap[targetCat];
          if (!targetHandle) return;
          prepareGhost(targetCat, targetHandle, wheelDir || (wheelDelta > 0 ? 1 : -1), true);
          wheelActive = true;
        }

        var progress = Math.min(1, Math.abs(wheelDelta) / dragWidth);
        var offset = baseOffset + (wheelDir > 0 ? -progress * dragWidth : progress * dragWidth);
        gridTrack.style.transition = 'none';
        gridTrack.style.transform = 'translateX(' + offset + 'px)';
        updateProgress(currentCat, dragCat, progress);

        if (Math.abs(wheelDelta) < 110) return;

        var dir = wheelDir || (wheelDelta > 0 ? 1 : -1);
        wheelDelta = 0;
        wheelStartTime = 0;
        wheelDir = 0;
        wheelLock = true;
        lastWheelTrigger = Date.now();

        dragDir = dir;
        updateProgress(currentCat, dragCat, 1);
        completeTransition();
        resetWheelState();
      },
      { passive: false }
    );

    var initialTutorialDelay = 0;
    var initialWaitDelay = deepLinkSyncActive ? 0 : 5000;
    window.setTimeout(function () {
      if (userHasScrolled) return;
      waitForInitialGrid(initialTutorialDelay);
    }, initialWaitDelay);
  })();

  /* ============================================================
   * 5) OVERLAY OPEN / CLOSE (INLINE CARD VIEW)
   * ============================================================ */

  var backBtn = document.querySelector('[data-htv-overlay-back]');
  var initialOverlayProducts = Array.prototype.slice.call(
    document.querySelectorAll('[data-htv-overlay-product]')
  );
  var gridScrollY = 0;
  var lastGridIndex = null;
  var overlayHistoryActive = false;
  var overlayTutorialShown = false;
  var overlayTutorialTimer = null;
  var overlayTutorialRunning = false;
  var overlayScrollAnimation = null;
  var overlayActiveIndex = null;
  var overlayViewStart = 0;
  var overlayScrollRaf = null;
  var overlayProgrammaticScroll = 0;

  if (!gridEl || !overlay || !scroller) {
    updateZoomButtonVisual();
    return;
  }

  function setOverlaySnapSuppressed(active) {
    if (!overlay) return;
    overlay.classList.toggle('htv-overlay--no-snap', active);
  }

  function setOverlayTutorialMode(active) {
    setOverlaySnapSuppressed(active);
  }

  function cancelOverlayTutorial() {
    if (overlayTutorialTimer) {
      window.clearTimeout(overlayTutorialTimer);
      overlayTutorialTimer = null;
    }
    overlayTutorialRunning = false;
    setOverlayTutorialMode(false);
    hideScrollHint();
  }

  function registerOverlayInteraction() {
    if (!overlayTutorialShown) {
      overlayTutorialShown = true;
    }
    cancelOverlayTutorial();
  }

  scroller.addEventListener('scroll', requestOverlayScrollUpdate, { passive: true });
  scroller.addEventListener('touchstart', registerOverlayInteraction, { passive: true });
  scroller.addEventListener('wheel', registerOverlayInteraction, { passive: true });
  scroller.addEventListener('pointerdown', registerOverlayInteraction, { passive: true });

  function trackProductView(index, source, meta) {
    var resolvedIndex = typeof index === 'number' ? index : parseInt(index, 10) || 0;
    var resolvedMeta = meta || getProductMetaByIndex(resolvedIndex);
    pushDataLayer('htv_product_view', {
      htv_category: currentCat,
      htv_collection_handle: page.getAttribute('data-htv-collection-handle') || '',
      htv_product_handle: resolvedMeta.handle,
      htv_product_title: resolvedMeta.title,
      htv_product_index: resolvedIndex,
      htv_view_source: source || ''
    });
  }

  function logOverlayDwell(index, durationMs, exitReason) {
    if (index === null || index === undefined) return;
    if (!durationMs || durationMs <= 0) return;
    var resolvedIndex = typeof index === 'number' ? index : parseInt(index, 10) || 0;
    var meta = getProductMetaByIndex(resolvedIndex);
    pushDataLayer('htv_product_dwell', {
      htv_category: currentCat,
      htv_collection_handle: page.getAttribute('data-htv-collection-handle') || '',
      htv_product_handle: meta.handle,
      htv_product_title: meta.title,
      htv_product_index: resolvedIndex,
      htv_dwell_ms: durationMs,
      htv_exit_reason: exitReason || ''
    });
  }

  function setOverlayActiveIndex(nextIndex, source, exitReason) {
    var resolvedIndex = typeof nextIndex === 'number' ? nextIndex : parseInt(nextIndex, 10) || 0;
    if (overlayActiveIndex === null) {
      overlayActiveIndex = resolvedIndex;
      overlayViewStart = Date.now();
      return;
    }
    if (resolvedIndex === overlayActiveIndex) return;
    if (!overlayTutorialRunning && overlayTutorialTimer && !overlayProgrammaticScroll) {
      window.clearTimeout(overlayTutorialTimer);
      overlayTutorialTimer = null;
      overlayTutorialShown = true;
    }
    var now = Date.now();
    logOverlayDwell(overlayActiveIndex, now - overlayViewStart, exitReason || 'swipe');
    overlayActiveIndex = resolvedIndex;
    overlayViewStart = now;
    trackProductView(resolvedIndex, source || 'overlay');
    try {
      window.dispatchEvent(new CustomEvent('htv:overlay-swipe', { detail: { index: resolvedIndex, source: source || 'overlay' } }));
    } catch (e) {}
  }

  function handleOverlayScroll() {
    if (!page.classList.contains('htv-page--overlay-active')) return;
    var viewport = scroller.clientHeight || window.innerHeight || 1;
    if (!viewport) return;
    var nextIndex = Math.round(scroller.scrollTop / viewport);
    if (nextIndex < 0) nextIndex = 0;
    setOverlayActiveIndex(nextIndex, 'overlay', 'swipe');
  }

  function requestOverlayScrollUpdate() {
    if (overlayScrollRaf) return;
    overlayScrollRaf = window.requestAnimationFrame(function () {
      overlayScrollRaf = null;
      handleOverlayScroll();
    });
  }

  (function enableOverlayMouseDrag() {
    if (!scroller) return;
    var overlayMouseDown = false;
    var overlayDragging = false;
    var overlayStartY = 0;
    var overlayStartX = 0;
    var overlayLastY = 0;
    var overlayLastX = 0;
    var overlayStartScroll = 0;

    function handleMove(e) {
      if (!overlayMouseDown) return;
      if (!page.classList.contains('htv-page--overlay-active')) return;
      var dyTotal = e.clientY - overlayStartY;
      var dxTotal = e.clientX - overlayStartX;

      if (!overlayDragging) {
        if (Math.abs(dyTotal) < 2) return;
        if (Math.abs(dyTotal) < Math.abs(dxTotal) * 0.6) return;
        overlayDragging = true;
        document.body.classList.add('htv-dragging');
        registerOverlayInteraction();
        setOverlaySnapSuppressed(true);
        if (overlayScrollAnimation) {
          window.cancelAnimationFrame(overlayScrollAnimation);
          overlayScrollAnimation = null;
        }
        scroller.style.scrollBehavior = 'auto';
      }

      e.preventDefault();
      scroller.scrollTop -= (e.clientY - overlayLastY);
      overlayLastY = e.clientY;
      overlayLastX = e.clientX;
    }

    function handleEnd() {
      if (!overlayMouseDown) return;
      overlayMouseDown = false;
      var wasDragging = overlayDragging;
      overlayDragging = false;
      document.body.classList.remove('htv-dragging');
      scroller.style.scrollBehavior = '';
      if (!wasDragging) {
        setOverlaySnapSuppressed(false);
        return;
      }

      var endY = overlayLastY;
      var deltaY = endY - overlayStartY;
      var viewport = scroller.clientHeight || 1;
      var threshold = viewport * 0.1;
      var overlays = Array.prototype.slice.call(
        scroller.querySelectorAll('[data-htv-overlay-product]')
      );
      if (!overlays.length) {
        setOverlaySnapSuppressed(false);
        return;
      }

      var startIndex = Math.round(overlayStartScroll / viewport);
      var targetIndex = startIndex;
      if (Math.abs(deltaY) >= threshold) {
        targetIndex = startIndex + (deltaY < 0 ? 1 : -1);
      }
      if (targetIndex < 0) targetIndex = 0;
      if (targetIndex > overlays.length - 1) targetIndex = overlays.length - 1;

      smoothScrollOverlayTo(overlays[targetIndex]);
    }

    document.addEventListener(
      'mousedown',
      function (e) {
        if (!page.classList.contains('htv-page--overlay-active')) return;
        if (e.button !== 0) return;
        if (!e.target.closest('[data-htv-overlay-scroller]')) return;
        overlayMouseDown = true;
        overlayDragging = false;
        overlayStartY = e.clientY;
        overlayStartX = e.clientX;
        overlayLastY = e.clientY;
        overlayLastX = e.clientX;
        overlayStartScroll = scroller.scrollTop;
      },
      true
    );

    document.addEventListener('mousemove', handleMove, true);
    document.addEventListener('mouseup', handleEnd, true);
  })();

  function clampValue(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function calcOverlayDuration(distance, min, max, factor) {
    return clampValue(Math.round(distance * factor), min, max);
  }

  function smoothScrollOverlayTo(target, options) {
    if (!scroller || !target) return;
    var opts = {};
    if (typeof options === 'number') {
      opts.offset = options;
    } else if (typeof options === 'function') {
      opts.onComplete = options;
    } else if (options && typeof options === 'object') {
      opts = options;
    }
    var scrollerTop = scroller.getBoundingClientRect().top;
    var targetTop = target.getBoundingClientRect().top;
    var startY = scroller.scrollTop;
    var scrollOffset = typeof opts.offset === 'number' ? opts.offset : 0;
    var onComplete = typeof opts.onComplete === 'function' ? opts.onComplete : null;
    var suppressSnap = opts.suppressSnap !== false;
    var releaseSnap = opts.releaseSnap !== false;
    var duration = typeof opts.duration === 'number' ? opts.duration : 520;
    var easing = typeof opts.easing === 'function' ? opts.easing : easeInOutCubic;
    var targetY = startY + (targetTop - scrollerTop) + scrollOffset;
    var maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
    if (targetY > maxScroll) targetY = maxScroll;
    if (targetY < 0) targetY = 0;
    var distance = targetY - startY;
    if (Math.abs(distance) < 1) return;

    if (overlayScrollAnimation) {
      window.cancelAnimationFrame(overlayScrollAnimation);
      overlayScrollAnimation = null;
      overlayProgrammaticScroll = Math.max(0, overlayProgrammaticScroll - 1);
    }

    var start = window.performance ? performance.now() : Date.now();
    if (suppressSnap) {
      setOverlaySnapSuppressed(true);
    }
    overlayProgrammaticScroll += 1;

    function step(now) {
      var current = window.performance ? now : Date.now();
      var elapsed = current - start;
      var t = Math.min(1, elapsed / duration);
      var eased = easing(t);
      scroller.scrollTop = startY + distance * eased;
      if (t < 1) {
        overlayScrollAnimation = window.requestAnimationFrame(step);
      } else {
        overlayScrollAnimation = null;
        if (releaseSnap) {
          setOverlaySnapSuppressed(false);
        }
        overlayProgrammaticScroll = Math.max(0, overlayProgrammaticScroll - 1);
        if (onComplete) {
          onComplete();
        }
      }
    }

    overlayScrollAnimation = window.requestAnimationFrame(step);
  }

  function smoothScrollOverlayPeek(target, peekOffset) {
    if (!peekOffset) {
      smoothScrollOverlayTo(target);
      return;
    }

    if (!scroller || !target) return;
    var scrollerTop = scroller.getBoundingClientRect().top;
    var targetTop = target.getBoundingClientRect().top;
    var startY = scroller.scrollTop;
    var targetY = startY + (targetTop - scrollerTop);
    var distance = targetY - startY;
    if (Math.abs(distance) < 1) {
      smoothScrollOverlayTo(target);
      return;
    }

    var direction = distance >= 0 ? 1 : -1;
    var overshoot = Math.abs(peekOffset) * direction;
    var absDistance = Math.abs(distance);
    var baseDuration = calcOverlayDuration(absDistance, 280, 900, 0.45);
    var overshootDuration = calcOverlayDuration(absDistance, 450, 1100, 0.5);
    var overshootOut = Math.max(180, Math.round(overshootDuration * 0.6));
    var overshootBack = Math.max(180, overshootDuration - overshootOut);

    smoothScrollOverlayTo(target, {
      offset: overshoot,
      duration: baseDuration + overshootOut,
      easing: easeOutCubic,
      releaseSnap: false,
      onComplete: function () {
        smoothScrollOverlayTo(target, {
          offset: 0,
          duration: overshootBack,
          easing: easeOutCubic
        });
      }
    });
  }

  function runOverlayTutorial() {
    if (overlayTutorialShown || overlayTutorialRunning) return;
    if (!page.classList.contains('htv-page--overlay-active')) return;
    if (!scroller) return;
    overlayTutorialShown = true;
    overlayTutorialRunning = true;
    setOverlayTutorialMode(true);
    showScrollHint();

    var startY = scroller.scrollTop;
    var viewport = scroller.clientHeight || window.innerHeight || 1;
    var travel = Math.min(Math.round(viewport * 0.45), 520);
    var targetY = startY + travel;
    var duration = 600;
    var hold = 600;
    var start = window.performance ? performance.now() : Date.now();

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(now) {
      if (!overlayTutorialRunning) return;
      var current = window.performance ? now : Date.now();
      var elapsed = current - start;
      if (elapsed <= duration) {
        var t = Math.min(1, elapsed / duration);
        var eased = easeInOut(t);
        scroller.scrollTop = startY + (targetY - startY) * eased;
        window.requestAnimationFrame(step);
        return;
      }

      if (elapsed <= duration + hold) {
        scroller.scrollTop = targetY;
        window.requestAnimationFrame(step);
        return;
      }

      var backElapsed = elapsed - duration - hold;
      var backT = Math.min(1, backElapsed / duration);
      var backEased = easeInOut(backT);
      scroller.scrollTop = targetY + (startY - targetY) * backEased;
      if (backT < 1) {
        window.requestAnimationFrame(step);
      } else {
        overlayTutorialRunning = false;
        setOverlayTutorialMode(false);
      }
    }

    window.requestAnimationFrame(step);
  }

  function scheduleOverlayTutorial() {
    if (overlayTutorialShown || overlayTutorialTimer) return;
    overlayTutorialTimer = window.setTimeout(function () {
      overlayTutorialTimer = null;
      runOverlayTutorial();
    }, 5000);
  }

  function openOverlay(index) {
    hideSwipeHint();
    hideScrollHint();
    lastGridIndex = index;
    gridScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    // Always find by data-htv-index so lazy-loaded sections work too
    var selector =
      '[data-htv-overlay-product][data-htv-index="' + index + '"]';
    var target = document.querySelector(selector);
    if (!target) return;

    // Lock background scroll & snap header/topbar into place
    window.scrollTo(0, 0);
    document.documentElement.classList.add('htv-no-scroll');
    document.body.classList.add('htv-no-scroll');

    page.classList.add('htv-page--overlay-active');
    updateBaseballFxState();
    if (!overlayHistoryActive && window.history && window.history.pushState) {
      window.history.pushState({ htvOverlay: true }, '', window.location.href);
      overlayHistoryActive = true;
    }

    var overshoot = 0;
    if (scroller) {
      var overlays = scroller.querySelectorAll('[data-htv-overlay-product]');
      var viewport = scroller.clientHeight || window.innerHeight || 0;
      if (overlays && overlays.length && index < overlays.length - 1) {
        overshoot = Math.min(Math.round(viewport * 0.48), 520);
      }
    }

    // Let scroll-snap handle positioning; compute offset relative to scroller
    window.requestAnimationFrame(function () {
      smoothScrollOverlayPeek(target, overshoot);
    });

    overlayActiveIndex = index;
    overlayViewStart = Date.now();
    trackProductView(index, 'grid');

    updateZoomButtonVisual();
    scheduleOverlayTutorial();
  }

  function waitForOverlayByHandle(handle, token, attempts) {
    if (!handle) return;
    var tries = typeof attempts === 'number' ? attempts : 80;
    var localToken = token || collectionRenderToken;
    function attempt() {
      if (localToken !== collectionRenderToken) return;
      var overlayMatch = scroller
        ? scroller.querySelector('[data-htv-overlay-product][data-htv-handle="' + handle + '"]')
        : null;
      if (overlayMatch) {
        var overlayIdxAttr = overlayMatch.getAttribute('data-htv-index');
        var overlayIdx = overlayIdxAttr ? parseInt(overlayIdxAttr, 10) : NaN;
        if (isNaN(overlayIdx)) {
          var overlays = scroller.querySelectorAll('[data-htv-overlay-product]');
          overlayIdx = Array.prototype.indexOf.call(overlays, overlayMatch);
        }
        if (!isNaN(overlayIdx) && overlayIdx >= 0) {
          openOverlay(overlayIdx);
          return;
        }
      }
      if (gridEl) {
        var item = gridEl.querySelector('[data-htv-item][data-htv-handle="' + handle + '"]');
        if (item) {
          var idxAttr = item.getAttribute('data-htv-index');
          var idx = idxAttr ? parseInt(idxAttr, 10) : NaN;
          if (!isNaN(idx)) {
            openOverlay(idx);
            return;
          }
        }
      }
      tries -= 1;
      if (tries <= 0) return;
      window.setTimeout(attempt, 150);
    }
    attempt();
  }

  function closeOverlay(fromHistory, skipHistory, exitReason) {
    var reason = exitReason || (fromHistory ? 'history_back' : 'close');
    if (overlayActiveIndex !== null && overlayViewStart) {
      logOverlayDwell(overlayActiveIndex, Date.now() - overlayViewStart, reason);
    }
    overlayActiveIndex = null;
    overlayViewStart = 0;
    if (overlayScrollRaf) {
      window.cancelAnimationFrame(overlayScrollRaf);
      overlayScrollRaf = null;
    }
    cancelOverlayTutorial();
    if (overlayScrollAnimation) {
      window.cancelAnimationFrame(overlayScrollAnimation);
      overlayScrollAnimation = null;
    }
    overlayProgrammaticScroll = 0;
    setOverlaySnapSuppressed(false);
    if (overlayHistoryActive && !fromHistory && !skipHistory && window.history && window.history.back) {
      window.history.back();
      return;
    }
    if (overlayHistoryActive && !fromHistory && skipHistory && window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.href);
    }
    page.classList.remove('htv-page--overlay-active');
    document.documentElement.classList.remove('htv-no-scroll');
    document.body.classList.remove('htv-no-scroll');
    updateBaseballFxState();
    restoreGridScroll();
    updateZoomButtonVisual();
    overlayHistoryActive = false;
  }

  function restoreGridScroll() {
    if (typeof gridScrollY !== 'number') return;
    var targetY = gridScrollY;
    window.scrollTo(0, targetY);
    window.requestAnimationFrame(function () {
      window.scrollTo(0, targetY);
      window.requestAnimationFrame(function () {
        var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (Math.abs(currentY - targetY) <= 2) return;
        if (!gridEl) return;
        if (lastGridIndex === null || lastGridIndex === undefined) return;
        var selector = '[data-htv-item][data-htv-index="' + lastGridIndex + '"]';
        var targetItem = gridEl.querySelector(selector);
        if (targetItem && targetItem.scrollIntoView) {
          targetItem.scrollIntoView({ block: 'center' });
        }
      });
    });
  }

  // Event delegation so it works for lazy-loaded tiles too
  gridEl.addEventListener('click', function (e) {
    markGridInteraction();
    var link = e.target.closest('.htv-grid__link');
    if (!link) return;
    e.preventDefault();
    if (suppressGridClick) {
      suppressGridClick = false;
      return;
    }

    var item = link.closest('[data-htv-item]');
    if (!item) return;

    e.preventDefault();
    var idx = parseInt(item.getAttribute('data-htv-index'), 10) || 0;
    openOverlay(idx);
  });

  gridEl.addEventListener('dragstart', function (e) {
    if (e.target.closest('.htv-grid__link')) {
      e.preventDefault();
    }
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      closeOverlay(false, true, 'back_button');
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeOverlay(false, true, 'escape_key');
    }
  });

  window.addEventListener('popstate', function () {
    if (page.classList.contains('htv-page--overlay-active')) {
      closeOverlay(true, false, 'history_back');
      return;
    }
    overlayHistoryActive = false;
  });

  // Zoom / back button behaviour
  if (zoomBtn) {
    var lastTapTime = 0;

    zoomBtn.addEventListener(
      'touchend',
      function (e) {
        var now = Date.now();
        if (now - lastTapTime < 350) {
          e.preventDefault();
        }
        lastTapTime = now;
      },
      { passive: false }
    );

    zoomBtn.addEventListener('click', function () {
      if (page.classList.contains('htv-page--overlay-active')) {
        // In overlay mode it just acts as "Back to grid"
        closeOverlay(false, true, 'zoom_button');
        return;
      }

      // Grid mode → zoom control
      var nextIndex = currentIndex + direction;
      if (nextIndex < 0 || nextIndex >= zoomClasses.length) {
        direction *= -1;
        nextIndex = currentIndex + direction;
      }
      currentIndex = nextIndex;

      if (currentIndex === zoomClasses.length - 1) {
        direction = -1;
      } else if (currentIndex === 0) {
        direction = 1;
      }

      applyZoom();
      updateZoomButtonVisual();
    });
  }

  /* ============================================================
   * 6) PINCH TO ZOOM GRID (MOBILE)
   * ============================================================ */

  (function enablePinchToZoom() {
    if (!page) return;

    var pinchActive = false;
    var pinchHandled = false;
    var startDist = 0;

    function getTouchDistance(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    page.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length === 2) {
          pinchActive = true;
          pinchHandled = false;
          startDist = getTouchDistance(e.touches);
          e.preventDefault();
        }
      },
      { passive: false }
    );

    page.addEventListener(
      'touchmove',
      function (e) {
        if (!pinchActive || e.touches.length !== 2) return;
        e.preventDefault();
        var dist = getTouchDistance(e.touches);
        if (!startDist) return;
        var scale = dist / startDist;
        if (pinchHandled) return;

        if (page.classList.contains('htv-page--overlay-active')) {
          pinchHandled = true;
          return;
        }

        if (scale > 1.08) {
          zoomInOneStep();
          pinchHandled = true;
        } else if (scale < 0.92) {
          zoomOutOneStep();
          pinchHandled = true;
        }
      },
      { passive: false }
    );

    page.addEventListener(
      'touchend',
      function (e) {
        if (e.touches.length < 2) {
          pinchActive = false;
          startDist = 0;
          pinchHandled = false;
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'gesturestart',
      function (e) {
        e.preventDefault();
      },
      { passive: false }
    );
    document.addEventListener(
      'gesturechange',
      function (e) {
        e.preventDefault();
      },
      { passive: false }
    );
    document.addEventListener(
      'gestureend',
      function (e) {
        e.preventDefault();
      },
      { passive: false }
    );
  })();

  /* ============================================================
   * 6) PER-PRODUCT OVERLAY INIT
   * ============================================================ */

  function initOverlayProduct(root) {
    if (!root) return;
    applyInventoryOverrideToOverlay(root);

    // ----- Slides / gallery -----
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-htv-slide]')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-htv-dot]')
    );
    var prevBtn = root.querySelector('[data-htv-prev]');
    var nextBtn = root.querySelector('[data-htv-next]');
    var currentSlide = 0;

    function showSlide(i) {
      if (!slides.length) return;
      currentSlide = (i + slides.length) % slides.length;
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === currentSlide);
      });
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === currentSlide);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        registerOverlayInteraction();
        showSlide(currentSlide - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        registerOverlayInteraction();
        showSlide(currentSlide + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        registerOverlayInteraction();
        var idx = parseInt(dot.getAttribute('data-index'), 10) || 0;
        showSlide(idx);
      });
    });

    // ----- Swipe gestures (mobile) -----
    var gallery = root.querySelector('.htv-overlay-product__gallery');
    if (gallery && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchMoved = false;
      var horizontalIntent = false;

      gallery.addEventListener(
        'touchstart',
        function (e) {
          var t = e.touches[0];
          touchStartX = t.clientX;
          touchStartY = t.clientY;
          touchMoved = false;
          horizontalIntent = false;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchmove',
        function (e) {
          var t = e.touches[0];
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;
          if (Math.abs(dx) > Math.abs(dy) * 0.8 && Math.abs(dx) > 8) {
            horizontalIntent = true;
            touchMoved = true;
            e.preventDefault();
          }
        },
        { passive: false }
      );

      gallery.addEventListener(
        'touchend',
        function (e) {
          if (!touchMoved || !horizontalIntent) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;

          if (Math.abs(dx) > 18 && Math.abs(dx) > Math.abs(dy) * 0.8) {
            e.preventDefault();
            if (dx < 0) {
              registerOverlayInteraction();
              showSlide(currentSlide + 1);
            } else {
              registerOverlayInteraction();
              showSlide(currentSlide - 1);
            }
          }
        },
        { passive: false }
      );
    }

    // ----- Variants + ATC -----
    var productFormEl = root.querySelector('[data-htv-atc-form]');
    var form = productFormEl ? productFormEl.querySelector('form') : null;
    var sizePills = Array.prototype.slice.call(
      root.querySelectorAll('.htv-overlay-product__size-pill')
    );
    var variantInput = root.querySelector('[data-htv-variant-input]');
    var addBtn = root.querySelector('[data-htv-add]');
    var addedMsg = root.querySelector('[data-htv-added]');

    var interestBlock = root.querySelector('[data-htv-interest]');
    var productHandle = root.getAttribute('data-htv-handle') || '';
    var productTitleEl = root.querySelector('.htv-overlay-product__title');
    var productTitle = productTitleEl ? productTitleEl.textContent : '';
    var forceSoldOut = isProductForcedSoldOut(productHandle, productTitle);

    function showInterestedState() {
      if (addBtn) addBtn.setAttribute('hidden', 'hidden');
      if (interestBlock) interestBlock.removeAttribute('hidden');
      if (addedMsg) addedMsg.classList.remove('is-visible');
    }

    function showAddToCartState() {
      if (interestBlock) interestBlock.setAttribute('hidden', 'hidden');
      if (addBtn) addBtn.removeAttribute('hidden');
    }

    function selectVariant(pill) {
      if (!pill) return;
      var isSoldOut = pill.classList.contains('is-sold-out');

      sizePills.forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');

      if (isSoldOut) {
        if (variantInput) variantInput.value = '';
        if (addBtn) addBtn.disabled = true;
        showInterestedState();
        return;
      }

      if (!variantInput || !addBtn) return;
      var vid = pill.getAttribute('data-variant-id');
      if (!vid) return;

      variantInput.value = vid;
      addBtn.disabled = false;
      showAddToCartState();

      if (addedMsg) addedMsg.classList.remove('is-visible');
    }

    sizePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        registerOverlayInteraction();
        selectVariant(pill);
      });
    });

    if (forceSoldOut) {
      if (variantInput) variantInput.value = '';
      if (addBtn) addBtn.disabled = true;
      showInterestedState();
      return;
    }

    // If there are no size pills (single-variant product), auto-enable ATC
    if (sizePills.length === 0 && variantInput && addBtn) {
      if (variantInput.value) {
        addBtn.disabled = false;
      }
    }

    if (form && addBtn) {
      // Let Dawn's product-form JS handle cart; we just show the "ADDED" toast
      form.addEventListener('submit', function () {
        if (!addedMsg) return;
        addedMsg.classList.add('is-visible');
        window.setTimeout(function () {
          addedMsg.classList.remove('is-visible');
        }, 1800);
      });
    }

    // ----- Info accordion -----
    var infoToggle = root.querySelector('[data-htv-info-toggle]');
    var infoBody = root.querySelector('[data-htv-info-body]');
    var wishBtn = root.querySelector('[data-htv-wish]');
    var shareBtn = root.querySelector('[data-htv-share]');
    var shareTimer = null;

    if (infoToggle && infoBody) {
      infoToggle.addEventListener('click', function () {
        registerOverlayInteraction();
        var isOpen = infoBody.classList.toggle('is-open');
        infoToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          root.classList.add('htv-overlay-product--info-open');
        } else {
          root.classList.remove('htv-overlay-product--info-open');
        }
      });

      // Close when clicking outside, or if another toggle is opened
      document.addEventListener('click', function (evt) {
        if (!infoBody.classList.contains('is-open')) return;
        var withinPanel = infoBody.contains(evt.target) || infoToggle.contains(evt.target);
        if (!withinPanel) {
          infoBody.classList.remove('is-open');
          infoToggle.setAttribute('aria-expanded', 'false');
          root.classList.remove('htv-overlay-product--info-open');
        }
      });
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        registerOverlayInteraction();
        var handle = root.getAttribute('data-htv-handle');
        var titleEl = root.querySelector('.htv-overlay-product__title');
        var shareUrl = buildShareUrl(handle);
        var shareTitle = titleEl ? titleEl.textContent.trim() : document.title;

        if (navigator.share) {
          navigator.share({ url: shareUrl, title: shareTitle })
            .then(function () {
              // Share sheet handled it; no message needed
            })
            .catch(function () {
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(shareUrl).catch(function () {});
              }
            });
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl)
            .then(function () {})
            .catch(function () {});
          return;
        }

        try {
          var temp = document.createElement('input');
          temp.value = shareUrl;
          document.body.appendChild(temp);
          temp.select();
          document.execCommand('copy');
          document.body.removeChild(temp);
        } catch (e) {
        }
      });
    }

    if (wishBtn) {
      wishBtn.addEventListener('click', function () {
        if (wishBtn.classList.contains('is-noted')) return;
        var index = parseInt(root.getAttribute('data-htv-index'), 10);
        var meta = getProductMetaByIndex(isNaN(index) ? 0 : index);
        pushDataLayer('htv_interested_click', {
          htv_category: currentCat,
          htv_collection_handle: page.getAttribute('data-htv-collection-handle') || '',
          htv_product_handle: meta.handle,
          htv_product_title: meta.title,
          htv_product_index: isNaN(index) ? 0 : index
        });
        wishBtn.classList.add('is-animating');
        window.setTimeout(function () {
          wishBtn.classList.remove('is-animating');
          wishBtn.classList.add('is-noted');
          wishBtn.setAttribute('disabled', 'disabled');
          wishBtn.textContent = 'NOTED';
        }, 280);
      });
    }
  }

  // Init all server-rendered overlay cards
  initialOverlayProducts.forEach(function (productRoot) {
    initOverlayProduct(productRoot);
  });
  document.querySelectorAll('img.htv-lazy-img').forEach(function (img) {
    setupLazyImage(img);
  });

  /* ============================================================
   * 7) LAZY-LOAD EXTRA PRODUCTS (FULL CARD EXPERIENCE)
   * ============================================================ */

  setupHtvLazyLoadOptionC();

  function setupHtvLazyLoadOptionC() {
    if (!page) return;

    var handle = page.getAttribute('data-htv-collection-handle');
    if (!handle) return;

    if (!gridEl || !scroller) return;

    var sentinel = document.querySelector('[data-htv-lazy-sentinel]');

    // How many items did Liquid render initially (48 for you)
    var initialCount = gridEl.querySelectorAll('[data-htv-item]').length;

    initPagination(handle, initialCount);
    paginationState.tagsSet = new Set(collectTagsFromDom());
    updateFilterOptions(Array.from(paginationState.tagsSet));
    updateFilterSelectValue();
    applyFilters();
    prefetchNextCategory(currentCat);

    var loadedPageOne = false;
    var allowAutoLoad = false;
    var pendingAutoLoad = false;
    var lazyTriggerObserver = null;
    var lazyTriggerIndex = -1;

    function loadFirstPageIfNeeded() {
      if (loadedPageOne) return;
      if (paginationState.page > 0) {
        loadedPageOne = true;
        return;
      }
      if (paginationState.loading) return;
      var handle = paginationState.handle;
      var initialCount = paginationState.initialCount || 0;
      var token = collectionRenderToken;
      var allowDeepLinkPagination =
        deepLinkPaginationCat && currentCat === deepLinkPaginationCat;

      if (!allowAutoLoad && !userHasScrolled && initialCount >= CATEGORY_PLACEHOLDER_COUNT && !allowDeepLinkPagination) {
        pendingAutoLoad = true;
        return;
      }

      loadedPageOne = true;

      if (initialCount > 0 && initialCount < CATEGORY_PLACEHOLDER_COUNT && handle) {
        prefetchCategory(handle, function (cache) {
          if (!cache || token !== collectionRenderToken) return;
          var existingCount = gridEl ? gridEl.querySelectorAll('[data-htv-item]').length : 0;
          var slice = cache.products.slice(existingCount, CATEGORY_PLACEHOLDER_COUNT);
          if (slice.length) {
            renderProductsInChunks(slice, existingCount, token, CATEGORY_PLACEHOLDER_COUNT, { keepOverlay: true });
            paginationState.initialCount = Math.max(paginationState.initialCount, CATEGORY_PLACEHOLDER_COUNT);
          }
        }, { limit: CATEGORY_PLACEHOLDER_COUNT });
        return;
      }

      fetchCollectionPage(1, paginationState.initialCount, { keepOverlay: true }).then(function () {
        if (typeof refreshLazyTrigger === 'function') refreshLazyTrigger();
      });
    }

    function loadNextPageIfNeeded() {
      if (paginationState.loading) return;
      if (paginationState.page === 0) {
        loadFirstPageIfNeeded();
        return;
      }
      if (paginationState.hasMore) {
        fetchCollectionPage(paginationState.page + 1, 0, { keepOverlay: true }).then(function () {
          if (typeof refreshLazyTrigger === 'function') refreshLazyTrigger();
        });
      }
    }

    function updateLazyTrigger() {
      if (!gridEl || paginationState.page === 0) return;
      if (!paginationState.hasMore) return;

      var targetIndex = paginationState.page * 250 - 50; // ~200 into current page
      if (targetIndex === lazyTriggerIndex) return;

      var items = gridEl.querySelectorAll('[data-htv-item]');
      if (items.length <= targetIndex) return;

      lazyTriggerIndex = targetIndex;
      if (lazyTriggerObserver) {
        lazyTriggerObserver.disconnect();
      }

      var target = items[targetIndex];
      if (!target || !('IntersectionObserver' in window)) return;

      lazyTriggerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadNextPageIfNeeded();
            }
          });
        },
        {
          root: null,
          rootMargin: '120px 0px',
          threshold: 0
        }
      );
      lazyTriggerObserver.observe(target);
    }

    refreshLazyTrigger = function () {
      window.setTimeout(updateLazyTrigger, 0);
    };

    // Timed auto-load of page 1 (gated by prefetch priority or user scroll)
    window.setTimeout(loadFirstPageIfNeeded, 1600);

    enableAutoLoad = function () {
      if (allowAutoLoad) return;
      allowAutoLoad = true;
      if (pendingAutoLoad) {
        loadFirstPageIfNeeded();
      }
    };

    prioritizeFirstPageLoad = function () {
      if (loadedPageOne) return;
      if (pendingAutoLoad) pendingAutoLoad = false;
      loadFirstPageIfNeeded();
    };

    requestActivePagination = function () {
      ensureActivePagination(collectionRenderToken);
    };

    if (userHasScrolled) {
      prioritizeFirstPageLoad();
    }

    // Scroll-triggered pagination
    if ('IntersectionObserver' in window && sentinel) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadFirstPageIfNeeded();
              if (!paginationState.hasMore && paginationState.page > 0) {
                io.disconnect();
              }
            }
          });
        },
        {
          root: null,
          rootMargin: '200px 0px',
          threshold: 0
        }
      );
      io.observe(sentinel);
    }
  }

  /* ---------------- HELPERS FOR LAZY LOAD ---------------- */

  /* ============================================================
   * 8) GLOBAL OVERLAY SWIPE TO CLOSE (mobile safety)
   * ============================================================ */

  (function enableOverlaySwipeToClose() {
    if (!overlay || !scroller || !('ontouchstart' in window || navigator.maxTouchPoints > 0)) return;

    var startX = 0;
    var startY = 0;
    var moved = false;
    var horizontalIntent = false;
    var skipClose = false;

    function resetTouch() {
      moved = false;
      horizontalIntent = false;
      skipClose = false;
    }

    scroller.addEventListener(
      'touchstart',
      function (e) {
        var t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        resetTouch();
        // Don't treat swipes that originate on the gallery as close gestures
        if (e.target && e.target.closest('.htv-overlay-product__gallery')) {
          skipClose = true;
        }
      },
      { passive: true }
    );

    scroller.addEventListener(
      'touchmove',
      function (e) {
        if (skipClose) return;
        var t = e.touches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) * 1.2 && Math.abs(dx) > 14) {
          horizontalIntent = true;
          moved = true;
          e.preventDefault();
        }
      },
      { passive: false }
    );

    scroller.addEventListener(
      'touchend',
      function (e) {
        if (!page.classList.contains('htv-page--overlay-active')) return;
        if (skipClose) return;
        if (!moved || !horizontalIntent) return;

        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;

        if (Math.abs(dx) > 28 && Math.abs(dx) > Math.abs(dy) * 1.1) {
          e.preventDefault();
          closeOverlay(false, true, 'swipe_close');
        }
      },
      { passive: false }
    );
  })();

  function normalizeCents(value) {
    var n = Number(value);
    if (isNaN(n)) return 0;
    // Shopify products.json exposes variant.price in dollars (e.g., 30.00).
    // Shopify.formatMoney expects cents. If the number is small, assume dollars and convert.
    if (n > -999 && n < 999) {
      return Math.round(n * 100);
    }
    return Math.round(n);
  }

  function formatMoney(value) {
    var cents = normalizeCents(value);
    try {
      if (window.Shopify && Shopify.formatMoney) {
        var fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {
      console.warn('HTV formatMoney fallback', e);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function setupLazyImage(img) {
    if (!img) return;
    img.setAttribute('draggable', 'false');
    img.draggable = false;
    var gridItem = img.closest('.htv-grid__item');
    if (gridItem) gridItem.classList.add('htv-grid__item--pending');
    function markLoaded() {
      var elapsed = Date.now() - htvPageLoadTime;
      var delay = Math.max(0, 1600 - elapsed);
      window.setTimeout(function () {
        img.classList.add('is-loaded');
        var wrap = img.closest('.htv-grid__image-wrap');
        if (wrap) wrap.classList.add('is-loaded');
        var slide = img.closest('.htv-overlay-product__slide');
        if (slide) slide.classList.add('is-loaded');
        if (gridItem) gridItem.classList.remove('htv-grid__item--pending');
      }, delay);
    }
    if (img.complete && img.naturalWidth > 0) {
      markLoaded();
      return;
    }
    img.addEventListener('load', markLoaded, { once: true });
  }

  var CHUNK_SIZE = 20;

  function sizedImage(src, size) {
    if (!src || !size) return src;
    var parts = src.split('?');
    var base = parts[0];
    var query = parts[1] ? '?' + parts[1] : '';
    if (base.indexOf('_' + size + 'x.') !== -1) return src;
    return base.replace(/(\.[^./?]+)$/, '_' + size + 'x$1') + query;
  }

  function renderProductsInChunks(products, startIndex, token, chunkSize, options) {
    var idx = startIndex || 0;
    var cursor = 0;
    var size = chunkSize || CHUNK_SIZE;

    function step() {
      if (token !== collectionRenderToken) return;
      var slice = products.slice(cursor, cursor + size);
      slice.forEach(function (prod, offset) {
        var index = idx + cursor + offset;
        appendLazyGridItem(prod, index, gridEl);
        appendLazyOverlayProduct(prod, index, scroller);
      });
      applyFilters(options);
      cursor += size;
      if (cursor < products.length) {
        window.setTimeout(step, 40);
      } else if (typeof refreshLazyTrigger === 'function') {
        refreshLazyTrigger();
      }
    }

    step();
  }

  function appendLazyGridItem(prod, index, gridEl) {
    try {
      var li = document.createElement('li');
      var variants = prod.variants || [];
      var available = getProductAvailability(prod.handle, prod.title, variants, prod.available);

      li.className =
        'htv-grid__item' + (available ? '' : ' htv-grid__item--sold-out');
      li.setAttribute('data-htv-item', 'true');
      li.setAttribute('data-htv-index', String(index));
      li.setAttribute('data-htv-handle', prod.handle || '');
      li.setAttribute(
        'data-htv-title',
        (prod.title || '').replace(/"/g, '&quot;')
      );
      li.setAttribute('data-htv-tags', (prod.tags || []).join('|'));
      li.setAttribute('data-htv-available', String(available));

      var link = document.createElement('a');
      link.className = 'htv-grid__link';
      link.href = '/products/' + encodeURIComponent(prod.handle || '');

      var imgWrap = document.createElement('div');
      imgWrap.className = 'htv-grid__image-wrap';

      var imgSrc =
        prod.images && prod.images.length ? prod.images[0].src : null;

      if (imgSrc) {
        var img = document.createElement('img');
        img.className = 'htv-grid__image htv-lazy-img';
        img.loading = 'lazy';
        img.src = sizedImage(imgSrc, 900);
        img.alt = prod.title || '';
        setupLazyImage(img);
        imgWrap.appendChild(img);
      }

      var meta = document.createElement('div');
      meta.className = 'htv-grid__meta';

      var titleSpan = document.createElement('span');
      titleSpan.className = 'htv-grid__title card__heading h5';
      titleSpan.textContent = prod.title || '';

      meta.appendChild(titleSpan);
      link.appendChild(imgWrap);
      link.appendChild(meta);
      li.appendChild(link);
      var placeholder = gridEl.querySelector('[data-htv-placeholder="true"]');
      if (placeholder) {
        placeholder.parentNode.replaceChild(li, placeholder);
      } else {
        gridEl.appendChild(li);
      }
      if (loadingCategory) updateLoadingProgress(loadingCategory);
    } catch (e) {
      console.error('HTV appendLazyGridItem error', e);
    }
  }

  function buildOverlayHtmlFromJson(prod, index) {
    var images = prod.images || [];
    var variants = prod.variants || [];
    var available = getProductAvailability(prod.handle, prod.title, variants, prod.available);
    var firstVariant = variants[0];

    var priceHtml = available && firstVariant
      ? formatMoney(firstVariant.price)
      : '';

    // GALLERY
    var slidesHtml = images.map(function (img, idx) {
      var active = idx === 0 ? ' is-active' : '';
      return (
        '<div class="htv-overlay-product__slide' + active + '" data-htv-slide data-index="' + idx + '">' +
          '<img class="htv-overlay-product__image htv-lazy-img" loading="lazy" src="' + sizedImage(img.src, 1200) + '" alt="' + (prod.title || '') + '">' +
        '</div>'
      );
    }).join('');

    var dotsHtml = '';
    if (images.length > 1) {
      dotsHtml =
        '<div class="htv-overlay-product__dots">' +
          images.map(function (_, idx) {
            return (
              '<button type="button" class="htv-overlay-product__dot' + (idx === 0 ? ' is-active' : '') +
              '" data-htv-dot data-index="' + idx +
              '" aria-label="Go to image ' + (idx + 1) + '"></button>'
            );
          }).join('') +
        '</div>';
    }

    var arrowsHtml = '';
    if (images.length > 1) {
      arrowsHtml =
        '<button type="button" class="htv-overlay-product__arrow htv-overlay-product__arrow--prev" data-htv-prev aria-label="Previous image">‹</button>' +
        '<button type="button" class="htv-overlay-product__arrow htv-overlay-product__arrow--next" data-htv-next aria-label="Next image">›</button>';
    }

    // SIZE PILLS
    var sizesHtml = '';
    var showSizePills = false;
    var hasSizeOption = Array.isArray(prod.options)
      && prod.options.some(function (opt) {
        return String(opt || '').trim().toLowerCase() === 'size';
      });

    if ((hasSizeOption || (isTeeProduct(prod.title) && available && variants.length > 1)) && variants.length) {
      showSizePills = true;
      var sizeOrder = getDisplaySizeOrder(prod.title, available);
      var variantBySize = {};
      variants.forEach(function (v) {
        var key = normalizeSizeLabel(v.option1 || v.title);
        if (key) variantBySize[key] = v;
      });
      sizesHtml =
        '<div class="htv-overlay-product__sizes" data-htv-sizes>' +
          '<div class="htv-overlay-product__sizes-header">SELECT SIZE</div>' +
          '<div class="htv-overlay-product__size-grid">' +
            sizeOrder.map(function (label) {
              var v = variantBySize[label];
              var av = getVariantAvailability(prod.handle, prod.title, v, label);
              var isSoldOut = !v || !av;
              return (
                '<button type="button" class="htv-overlay-product__size-pill' + (isSoldOut ? ' is-sold-out' : '') + '"' +
                  (v ? ' data-variant-id="' + v.id + '"' : '') + '>' +
                  '<span class="htv-overlay-product__size-label">' + label + '</span>' +
                  (isSoldOut ? '<span class="htv-overlay-product__size-strike"></span>' : '') +
                '</button>'
              );
            }).join('') +
          '</div>' +
        '</div>';
    } else if (variants.length > 1) {
      showSizePills = true;
      sizesHtml =
        '<div class="htv-overlay-product__sizes" data-htv-sizes>' +
          '<div class="htv-overlay-product__sizes-header">SELECT SIZE</div>' +
          '<div class="htv-overlay-product__size-grid">' +
            variants.map(function (v) {
              var av = getVariantAvailability(prod.handle, prod.title, v, v.title);
              return (
                '<button type="button" class="htv-overlay-product__size-pill' + (av ? '' : ' is-sold-out') +
                '" data-variant-id="' + v.id + '">' +
                  '<span class="htv-overlay-product__size-label">' + v.title + '</span>' +
                  (av ? '' : '<span class="htv-overlay-product__size-strike"></span>') +
                '</button>'
              );
            }).join('') +
          '</div>' +
        '</div>';
    }

    // PRODUCT FORM (only if available)
    var purchaseHtml = '';
    if (available && firstVariant) {
      purchaseHtml =
        '<div class="htv-overlay-product__purchase">' +
          '<product-form class="htv-overlay-product__form" data-htv-atc-form>' +
            '<form method="post" action="/cart/add" ' +
              'id="htv-product-form-' + prod.id + '" ' +
              'class="htv-overlay-product__form-inner" ' +
              'novalidate="novalidate" data-type="add-to-cart-form">' +

              '<input type="hidden" name="id" value="' + firstVariant.id + '" data-htv-variant-input>' +

              sizesHtml +

              '<button type="submit" name="add" class="htv-overlay-product__add-btn" data-htv-add' +
                (showSizePills ? ' disabled' : '') + '>' +
                '<span>ADD TO CART</span>' +
                '<div class="loading-overlay__spinner hidden"></div>' +
              '</button>' +

              '<div class="htv-overlay-product__added" data-htv-added>ADDED ✓</div>' +
            '</form>' +
          '</product-form>' +
          '<div class="htv-overlay-product__interest" data-htv-interest hidden>' +
            '<button type="button" class="htv-overlay-product__wish-btn" data-htv-wish data-htv-interested-target="HtvInterestedSignup-' + prod.id + '" data-htv-product-handle="' + (prod.handle || '') + '" data-htv-product-title="' + (prod.title || '').replace(/"/g, '&quot;') + '">I\'M INTERESTED IN THIS</button>' +
            '<form method="post" action="/contact#contact_form" accept-charset="UTF-8" class="htv-interested-signup__form" data-htv-interested-form>' +
              '<input type="hidden" name="form_type" value="customer">' +
              '<input type="hidden" name="utf8" value="✓">' +
              '<input type="hidden" name="contact[tags]" value="newsletter">' +
              '<div class="htv-interested-signup" id="HtvInterestedSignup-' + prod.id + '" data-htv-interested-signup hidden>' +
                '<div class="htv-interested-signup__inner">' +
                  '<p class="htv-interested-signup__eyebrow">Restock alert</p>' +
                  '<h3 class="htv-interested-signup__heading">Notify me when this is back</h3>' +
                  '<div class="htv-interested-signup__field field">' +
                    '<input id="HtvInterestedEmail-' + prod.id + '" type="email" name="contact[email]" class="field__input" aria-required="true" autocorrect="off" autocapitalize="off" autocomplete="email" placeholder="Email address" required>' +
                    '<label class="field__label" for="HtvInterestedEmail-' + prod.id + '">Email address</label>' +
                    '<button type="submit" class="htv-interested-signup__button field__button" name="commit">LMK</button>' +
                  '</div>' +
                  '<h3 class="htv-interested-signup__message htv-interested-signup__message--success form__message" data-htv-interested-success hidden>' +
                    'We\'ll email you if/when this restocks.' +
                  '</h3>' +
                '</div>' +
              '</div>' +
            '</form>' +
          '</div>' +
        '</div>';
    } else {
      purchaseHtml =
        '<div class="htv-overlay-product__purchase">' +
          '<button type="button" class="htv-overlay-product__wish-btn" data-htv-wish data-htv-interested-target="HtvInterestedSignup-' + prod.id + '" data-htv-product-handle="' + (prod.handle || '') + '" data-htv-product-title="' + (prod.title || '').replace(/"/g, '&quot;') + '">I\'M INTERESTED IN THIS</button>' +
          '<form method="post" action="/contact#contact_form" accept-charset="UTF-8" class="htv-interested-signup__form" data-htv-interested-form>' +
            '<input type="hidden" name="form_type" value="customer">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="contact[tags]" value="newsletter">' +
            '<div class="htv-interested-signup" id="HtvInterestedSignup-' + prod.id + '" data-htv-interested-signup hidden>' +
              '<div class="htv-interested-signup__inner">' +
                '<p class="htv-interested-signup__eyebrow">Restock alert</p>' +
                '<h3 class="htv-interested-signup__heading">Notify me when this is back</h3>' +
                '<div class="htv-interested-signup__field field">' +
                  '<input id="HtvInterestedEmail-' + prod.id + '" type="email" name="contact[email]" class="field__input" aria-required="true" autocorrect="off" autocapitalize="off" autocomplete="email" placeholder="Email address" required>' +
                  '<label class="field__label" for="HtvInterestedEmail-' + prod.id + '">Email address</label>' +
                  '<button type="submit" class="htv-interested-signup__button field__button" name="commit">LMK</button>' +
                '</div>' +
                '<h3 class="htv-interested-signup__message htv-interested-signup__message--success form__message" data-htv-interested-success hidden>' +
                  'We\'ll email you if/when this restocks.' +
                '</h3>' +
              '</div>' +
            '</div>' +
          '</form>' +
        '</div>';
    }

    // DESCRIPTION – keep HTML formatting
    var descriptionHtml = '';
    if (available) {
      var shareIcon =
        '<svg width="13" height="12" viewBox="0 0 13 12" class="icon icon-share" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
          '<path d="M1.625 8.125V10.2917C1.625 10.579 1.73914 10.8545 1.9423 11.0577C2.14547 11.2609 2.42102 11.375 2.70833 11.375H10.2917C10.579 11.375 10.8545 11.2609 11.0577 11.0577C11.2609 10.8545 11.375 10.579 11.375 10.2917V8.125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.14775 1.27137C6.34301 1.0761 6.65959 1.0761 6.85485 1.27137L9.56319 3.9797C9.75845 4.17496 9.75845 4.49154 9.56319 4.6868C9.36793 4.88207 9.05135 4.88207 8.85609 4.6868L6.5013 2.33203L4.14652 4.6868C3.95126 4.88207 3.63468 4.88207 3.43942 4.6868C3.24415 4.49154 3.24415 4.17496 3.43942 3.9797L6.14775 1.27137Z" fill="currentColor"/>' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1.125C6.77614 1.125 7 1.34886 7 1.625V8.125C7 8.40114 6.77614 8.625 6.5 8.625C6.22386 8.625 6 8.40114 6 8.125V1.625C6 1.34886 6.22386 1.125 6.5 1.125Z" fill="currentColor"/>' +
        '</svg>';
      descriptionHtml =
        '<div class="htv-overlay-product__info">' +
          '<div class="htv-overlay-product__info-actions">' +
            '<button type="button" class="htv-overlay-product__info-toggle" data-htv-info-toggle aria-expanded="false">' +
              'INFORMATION' +
            '</button>' +
            '<button type="button" class="htv-overlay-product__share-btn" data-htv-share aria-label="Share">' +
              shareIcon +
            '</button>' +
          '</div>' +
          '<div class="htv-overlay-product__info-body" data-htv-info-body>' +
            '<div class="htv-overlay-product__info-inner rte">' +
              (prod.body_html || '') +
            '</div>' +
          '</div>' +
        '</div>';
    }

    return (
      '<section class="htv-overlay-product" data-htv-overlay-product data-htv-index="' + index + '" data-htv-handle="' + (prod.handle || '') + '" data-htv-tags="' + (prod.tags || []).join('|').replace(/"/g, '&quot;') + '" data-htv-available="' + String(available) + '">' +
        '<div class="htv-overlay-product__inner">' +
          '<div class="htv-overlay-product__gallery">' +
            slidesHtml + arrowsHtml + dotsHtml +
          '</div>' +
          '<div class="htv-overlay-product__details">' +
            '<div class="htv-overlay-product__summary">' +
              '<h1 class="htv-overlay-product__title">' + (prod.title || '') + '</h1>' +
              (priceHtml ? '<div class="htv-overlay-product__price">' + priceHtml + '</div>' : '') +
              purchaseHtml +
            '</div>' +
            descriptionHtml +
          '</div>' +
        '</div>' +
      '</section>'
    );
  }

  function appendLazyOverlayProduct(prod, index, scroller) {
    var html = buildOverlayHtmlFromJson(prod, index);
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var section = temp.firstElementChild;
    if (!section) return;

    scroller.appendChild(section);
    initOverlayProduct(section);
    section.querySelectorAll('img.htv-lazy-img').forEach(function (img) {
      setupLazyImage(img);
    });
  }

  // Make sure zoom/back icon starts correctly
  updateZoomButtonVisual();
  updateBaseballFxState();
  document.addEventListener('visibilitychange', updateBaseballFxState);
  window.addEventListener('htv:overlay-swipe', function () {
    if (currentCat !== 'baseball') return;
    burstBaseballs(12);
  });
  window.addEventListener('beforeunload', clearBaseballFx);
});
